/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddFeedbackInput,
  AssignCaseRequest,
  CaseCategoryListResponse,
  CaseListResponse,
  CaseResponse,
  CaseStatisticsQueryRequest,
  CaseTypeListResponse,
  CaseTypeResponse,
  CloseCaseRequest,
  CreateCaseEntityRequest,
  CreateCaseEventRequest,
  CreateCaseRequest,
  CreateCaseSourceRequest,
  CustomFieldRequest,
  CustomFieldValueRequest,
  MttxMetricsGraphResponse,
  SecurityWidgetMetricsResponse,
  SecurityWidgetQueryRequest,
  SeverityChangeRequest,
  StatusChangeRequest,
  UpdateCaseRequest,
  UpdateCaseTypeRequest,
} from '../models/index';
import {
    AddFeedbackInputFromJSON,
    AddFeedbackInputToJSON,
    AssignCaseRequestFromJSON,
    AssignCaseRequestToJSON,
    CaseCategoryListResponseFromJSON,
    CaseCategoryListResponseToJSON,
    CaseListResponseFromJSON,
    CaseListResponseToJSON,
    CaseResponseFromJSON,
    CaseResponseToJSON,
    CaseStatisticsQueryRequestFromJSON,
    CaseStatisticsQueryRequestToJSON,
    CaseTypeListResponseFromJSON,
    CaseTypeListResponseToJSON,
    CaseTypeResponseFromJSON,
    CaseTypeResponseToJSON,
    CloseCaseRequestFromJSON,
    CloseCaseRequestToJSON,
    CreateCaseEntityRequestFromJSON,
    CreateCaseEntityRequestToJSON,
    CreateCaseEventRequestFromJSON,
    CreateCaseEventRequestToJSON,
    CreateCaseRequestFromJSON,
    CreateCaseRequestToJSON,
    CreateCaseSourceRequestFromJSON,
    CreateCaseSourceRequestToJSON,
    CustomFieldRequestFromJSON,
    CustomFieldRequestToJSON,
    CustomFieldValueRequestFromJSON,
    CustomFieldValueRequestToJSON,
    MttxMetricsGraphResponseFromJSON,
    MttxMetricsGraphResponseToJSON,
    SecurityWidgetMetricsResponseFromJSON,
    SecurityWidgetMetricsResponseToJSON,
    SecurityWidgetQueryRequestFromJSON,
    SecurityWidgetQueryRequestToJSON,
    SeverityChangeRequestFromJSON,
    SeverityChangeRequestToJSON,
    StatusChangeRequestFromJSON,
    StatusChangeRequestToJSON,
    UpdateCaseRequestFromJSON,
    UpdateCaseRequestToJSON,
    UpdateCaseTypeRequestFromJSON,
    UpdateCaseTypeRequestToJSON,
} from '../models/index';

export interface AddEntityToCaseRequest {
    caseId: string;
    createCaseEntityRequest: Array<CreateCaseEntityRequest>;
    sessionId?: string;
}

export interface AddEventToCaseRequest {
    caseId: string;
    createCaseEventRequest: CreateCaseEventRequest;
    sessionId?: string;
}

export interface AddFeedbackRequest {
    id: string;
    feedback: string;
    tenantIds?: string;
}

export interface AddNoteRequest {
    id: string;
    content: string;
    tenantIds?: string;
    noteType?: string;
}

export interface AddSourceToCaseRequest {
    caseId: string;
    createCaseSourceRequest: CreateCaseSourceRequest;
    sessionId?: string;
}

export interface AddStructuredFeedbackRequest {
    id: string;
    addFeedbackInput: AddFeedbackInput;
    tenantIds?: string;
}

export interface AssignCaseOperationRequest {
    caseId: string;
    assignCaseRequest: AssignCaseRequest;
    sessionId?: string;
}

export interface ChangeOwnerRequest {
    caseId: string;
    assignCaseRequest: AssignCaseRequest;
    sessionId?: string;
}

export interface ChangeSeverityRequest {
    caseId: string;
    severityChangeRequest: SeverityChangeRequest;
    sessionId?: string;
}

export interface ChangeStatusRequest {
    caseId: string;
    statusChangeRequest: StatusChangeRequest;
    sessionId?: string;
}

export interface CreateCaseOperationRequest {
    createCaseRequest: CreateCaseRequest;
    tenantIds?: string;
}

export interface DeEscalateCaseRequest {
    caseId: string;
    reason?: string;
    sessionId?: string;
}

export interface DeleteCaseRequest {
    id: string;
}

export interface DeleteCaseEventRequest {
    caseId: string;
    eventId: string;
}

export interface DeleteCaseFeedbackRequest {
    caseId: string;
    feedbackId: string;
}

export interface EscalateCaseRequest {
    caseId: string;
    reason?: string;
    sessionId?: string;
}

export interface GetCaseRequest {
    id: string;
    tenantIds?: string;
}

export interface GetCaseFeedbackRequest {
    id: string;
    tenantIds?: string;
}

export interface GetCaseStatisticsRequest {
    tenantIds?: string;
    createdFrom?: Date;
    createdTo?: Date;
    severity?: string;
    status?: string;
    owner?: string;
    escalated?: boolean;
    search?: string;
    id?: string;
    sourceId?: string;
    tenantId?: string;
    tenantName?: string;
    updatedFrom?: Date;
    updatedTo?: Date;
    entities?: string;
    events?: string;
    matchCase?: boolean;
    wholeWord?: boolean;
    useRegex?: boolean;
    resolutionReasonValues?: string;
}

export interface GetCaseTypesRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: GetCaseTypesSortOrderEnum;
}

export interface GetCaseTypesByCategoryRequest {
    category: string;
    pageParam?: string;
    pageSizeParam?: string;
}

export interface GetCaseTypesByCategory1Request {
    category: string;
    pageParam?: string;
    pageSizeParam?: string;
}

export interface GetCasesRequest {
    tenantIds?: string;
    page?: string;
    pageSize?: string;
    includeCollections?: boolean;
    include?: string;
    severity?: string;
    status?: string;
    owner?: string;
    escalated?: boolean;
    excludedCaseIds?: string;
    resolutionReasonValues?: string;
    search?: string;
    sourceId?: string;
    sourceTechnology?: string;
    id?: string;
    type?: string;
    tenantId?: string;
    tenantName?: string;
    createdFrom?: Date;
    createdTo?: Date;
    updatedFrom?: Date;
    updatedTo?: Date;
    entities?: string;
    events?: string;
    matchCase?: boolean;
    wholeWord?: boolean;
    useRegex?: boolean;
    sortBy?: string;
    sortOrder?: GetCasesSortOrderEnum;
}

export interface GetCreatableCaseTypes1Request {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: GetCreatableCaseTypes1SortOrderEnum;
}

export interface GetMttxGraphMetricsRequest {
    lookback: string;
    tenantIds?: string;
}

export interface GetRelatedCasesRequest {
    id: string;
    tenantIds?: string;
}

export interface PostSecurityWidgetMetricsRequest {
    securityWidgetQueryRequest: SecurityWidgetQueryRequest;
    tenantIds?: string;
}

export interface QueryCaseStatisticsRequest {
    caseStatisticsQueryRequest: CaseStatisticsQueryRequest;
    tenantIds?: string;
}

export interface RemoveCaseCustomFieldRequest {
    caseId: string;
    fieldKey: string;
    sessionId?: string;
}

export interface ReopenCaseRequest {
    id: string;
    reason: string;
    tenantIds?: string;
}

export interface ResolveCaseRequest {
    id: string;
    closeCaseRequest: CloseCaseRequest;
    tenantIds?: string;
}

export interface SetCustomFieldRequest {
    caseId: string;
    fieldKey: string;
    customFieldValueRequest: CustomFieldValueRequest;
    sessionId?: string;
}

export interface UnassignCaseRequest {
    caseId: string;
    reason?: string;
    sessionId?: string;
}

export interface UpdateCaseOperationRequest {
    id: string;
    updateCaseRequest: UpdateCaseRequest;
}

export interface UpdateCaseTypeOperationRequest {
    id: string;
    updateCaseTypeRequest: UpdateCaseTypeRequest;
    sessionId?: string;
}

export interface UpdateCustomFieldsRequest {
    caseId: string;
    customFieldRequest: CustomFieldRequest;
    sessionId?: string;
}

export interface UpdateEventRequest {
    caseId: string;
    eventId: string;
    requestBody: { [key: string]: any; };
}

/**
 * CasesApi - interface
 * 
 * @export
 * @interface CasesApiInterface
 */
export interface CasesApiInterface {
    /**
     * Adds one or more entities to an existing case.  **Entity Types:** - `HOST`: Hostname, IP address, or system identifier - `USER`: Username, email, or user identifier - `FILE`: File path, hash, or file identifier - `PROCESS`: Process name, PID, or process identifier - `NETWORK`: Network address, port, or connection identifier - `DOMAIN`: Domain name or URL - `EMAIL`: Email address or email identifier - `CUSTOM`: Custom entity type  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Entities are automatically associated with the case\'s tenant 
     * @summary Add entities to case
     * @param {string} caseId Case ID
     * @param {Array<CreateCaseEntityRequest>} createCaseEntityRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    addEntityToCaseRaw(requestParameters: AddEntityToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Adds one or more entities to an existing case.  **Entity Types:** - `HOST`: Hostname, IP address, or system identifier - `USER`: Username, email, or user identifier - `FILE`: File path, hash, or file identifier - `PROCESS`: Process name, PID, or process identifier - `NETWORK`: Network address, port, or connection identifier - `DOMAIN`: Domain name or URL - `EMAIL`: Email address or email identifier - `CUSTOM`: Custom entity type  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Entities are automatically associated with the case\'s tenant 
     * Add entities to case
     */
    addEntityToCase(requestParameters: AddEntityToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Adds a new event to an existing case.  **Event Types:** - `note`: General notes or comments - `case_created`: Case creation event - `case_assigned`: Case assignment event - `case_escalated`: Case escalation event - `case_closed`: Case closure event - `case_reopened`: Case reopening event - `case_feedback`: Case feedback event - `case_resolved`: Case resolution event - `status_change`: Status change event - `feedback`: General feedback event - `case_updated`: Case update event - `case_owner_changed`: Owner change event - `case_severity_changed`: Severity change event - `case_escalation_cleared`: Escalation cleared event - `comment`: Comment event - `EVIDENCE`: Evidence collection event - `INVESTIGATION`: Investigation event - `ANALYSIS`: Analysis event - `RESPONSE`: Response event  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Event is automatically associated with the case\'s tenant 
     * @summary Add event to case
     * @param {string} caseId Case ID
     * @param {CreateCaseEventRequest} createCaseEventRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    addEventToCaseRaw(requestParameters: AddEventToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Adds a new event to an existing case.  **Event Types:** - `note`: General notes or comments - `case_created`: Case creation event - `case_assigned`: Case assignment event - `case_escalated`: Case escalation event - `case_closed`: Case closure event - `case_reopened`: Case reopening event - `case_feedback`: Case feedback event - `case_resolved`: Case resolution event - `status_change`: Status change event - `feedback`: General feedback event - `case_updated`: Case update event - `case_owner_changed`: Owner change event - `case_severity_changed`: Severity change event - `case_escalation_cleared`: Escalation cleared event - `comment`: Comment event - `EVIDENCE`: Evidence collection event - `INVESTIGATION`: Investigation event - `ANALYSIS`: Analysis event - `RESPONSE`: Response event  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Event is automatically associated with the case\'s tenant 
     * Add event to case
     */
    addEventToCase(requestParameters: AddEventToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Submits feedback for a case with field-level permission validation
     * @summary Submit case feedback
     * @param {string} id Case ID
     * @param {string} feedback Feedback content
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Add feedback to a case from a specific tenant context.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    addFeedbackRaw(requestParameters: AddFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Submits feedback for a case with field-level permission validation
     * Submit case feedback
     */
    addFeedback(requestParameters: AddFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Adds a note to an existing case with field-level permission validation
     * @summary Add note to case
     * @param {string} id Case ID
     * @param {string} content Note content
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Add a note to a case from a specific tenant context.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {string} [noteType] Note type (optional)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    addNoteRaw(requestParameters: AddNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Adds a note to an existing case with field-level permission validation
     * Add note to case
     */
    addNote(requestParameters: AddNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Adds a new source to an existing case.  **Source Technologies:** - `MSFT_XDR`: Microsoft XDR - `PALO_ALTO_XDR`: Palo Alto XDR - `PALO_ALTO_XSOAR`: Palo Alto XSOAR - `MSFT_SENTINEL`: Microsoft Sentinel - `CROWDSTRIKE`: CrowdStrike Falcon - `SENTINELONE`: SentinelOne - `SPLUNK`: Splunk - `QRADAR`: IBM QRadar - `NESSUS`: Tenable Nessus - `QUALYS`: Qualys - `RAPID7`: Rapid7 - `RSA_ARCHER`: RSA Archer - `SERVICENOW`: ServiceNow - `ETL_PIPELINE`: ETL Pipeline - `WEB_APP`: Web Application - `EMAIL`: Email - `UNKNOWN`: Unknown  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Source is automatically associated with the case\'s tenant 
     * @summary Add source to case
     * @param {string} caseId Case ID
     * @param {CreateCaseSourceRequest} createCaseSourceRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    addSourceToCaseRaw(requestParameters: AddSourceToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Adds a new source to an existing case.  **Source Technologies:** - `MSFT_XDR`: Microsoft XDR - `PALO_ALTO_XDR`: Palo Alto XDR - `PALO_ALTO_XSOAR`: Palo Alto XSOAR - `MSFT_SENTINEL`: Microsoft Sentinel - `CROWDSTRIKE`: CrowdStrike Falcon - `SENTINELONE`: SentinelOne - `SPLUNK`: Splunk - `QRADAR`: IBM QRadar - `NESSUS`: Tenable Nessus - `QUALYS`: Qualys - `RAPID7`: Rapid7 - `RSA_ARCHER`: RSA Archer - `SERVICENOW`: ServiceNow - `ETL_PIPELINE`: ETL Pipeline - `WEB_APP`: Web Application - `EMAIL`: Email - `UNKNOWN`: Unknown  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Source is automatically associated with the case\'s tenant 
     * Add source to case
     */
    addSourceToCase(requestParameters: AddSourceToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Submits structured feedback (thumbs up/down, ratings, etc.) for a case with field-level permission validation
     * @summary Submit structured case feedback
     * @param {string} id Case ID
     * @param {AddFeedbackInput} addFeedbackInput 
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Add structured feedback to a case from a specific tenant context.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    addStructuredFeedbackRaw(requestParameters: AddStructuredFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Submits structured feedback (thumbs up/down, ratings, etc.) for a case with field-level permission validation
     * Submit structured case feedback
     */
    addStructuredFeedback(requestParameters: AddStructuredFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Assigns a case to a specific user for investigation or handling
     * @summary Assign case to user
     * @param {string} caseId Case ID
     * @param {AssignCaseRequest} assignCaseRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    assignCaseRaw(requestParameters: AssignCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Assigns a case to a specific user for investigation or handling
     * Assign case to user
     */
    assignCase(requestParameters: AssignCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Changes the owner of a case to a different user
     * @summary Change case owner
     * @param {string} caseId Case ID
     * @param {AssignCaseRequest} assignCaseRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    changeOwnerRaw(requestParameters: ChangeOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Changes the owner of a case to a different user
     * Change case owner
     */
    changeOwner(requestParameters: ChangeOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Changes the severity level of a case with optional reason
     * @summary Change case severity
     * @param {string} caseId Case ID
     * @param {SeverityChangeRequest} severityChangeRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    changeSeverityRaw(requestParameters: ChangeSeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Changes the severity level of a case with optional reason
     * Change case severity
     */
    changeSeverity(requestParameters: ChangeSeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Changes the status of a case to a new status with optional reason
     * @summary Change case status
     * @param {string} caseId Case ID
     * @param {StatusChangeRequest} statusChangeRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    changeStatusRaw(requestParameters: ChangeStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Changes the status of a case to a new status with optional reason
     * Change case status
     */
    changeStatus(requestParameters: ChangeStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Creates a new security case with case type permission validation.  **Required Fields:** - `name`: Case name/title (required) - `severity`: Case severity level (required)  **Optional Fields:** - `summary`: Detailed case description - `case_type_id`: ID of the case type - `owner`: Case owner/assignee - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:create permission - Case type creation requires specific category permissions - Field-level permissions are validated for sensitive operations  **Security & Access Control:** - All cases are created in the current tenant context - Case type permissions are validated - All creation actions are audited for compliance 
     * @summary Create new case
     * @param {CreateCaseRequest} createCaseRequest 
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **IMPORTANT:** For case creation, only the FIRST tenant ID will be used. Cases must be created in a single tenant.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, the case will be created in the session\&#39;s current tenant.  **Two Approaches for Cross-Tenant Access:**  1. **Per-Request Override (this parameter):** Specify tenantIds on each request    - Use when you need temporary access to a different tenant    - Example: &#x60;POST /cases?tenantIds&#x3D;other-tenant-id&#x60;  2. **Session-Based Selection:** Update your session\&#39;s selected tenants    - Use &#x60;POST /sessions/{sessionId}/select-tenants&#x60; to select multiple tenants    - Selected tenants persist across all requests until changed    - Preferred for ongoing cross-tenant operations    - Example: Select tenants A and B, then all case operations see both  **Note:** The @TenantSelection aspect handles tenant validation and context setup automatically. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    createCaseRaw(requestParameters: CreateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Creates a new security case with case type permission validation.  **Required Fields:** - `name`: Case name/title (required) - `severity`: Case severity level (required)  **Optional Fields:** - `summary`: Detailed case description - `case_type_id`: ID of the case type - `owner`: Case owner/assignee - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:create permission - Case type creation requires specific category permissions - Field-level permissions are validated for sensitive operations  **Security & Access Control:** - All cases are created in the current tenant context - Case type permissions are validated - All creation actions are audited for compliance 
     * Create new case
     */
    createCase(requestParameters: CreateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * De-escalates a case, removing the escalated flag and changing status back to IN_PROGRESS
     * @summary De-escalate case
     * @param {string} caseId Case ID
     * @param {string} [reason] Reason for de-escalation
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    deEscalateCaseRaw(requestParameters: DeEscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * De-escalates a case, removing the escalated flag and changing status back to IN_PROGRESS
     * De-escalate case
     */
    deEscalateCase(requestParameters: DeEscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * **PERMANENTLY DELETES** a case and all related data. This is a **HARD DELETE** operation that:  • Completely removes the case from the database • Deletes ALL related events, entities, sources, feedback, and close reasons • Cannot be undone - the case and all associated data is permanently lost • Maintains audit trail of the deletion operation  **Warning**: This operation is irreversible. Consider exporting case data before deletion if needed for compliance or historical purposes.  **Related Data Deleted:** - All timeline events - All case entities (IOCs, indicators) - All case sources - All case feedback entries - Close reason (if exists)  **Security**: Requires `cases:remove` permission and MAC policy compliance. 
     * @summary Permanently delete case
     * @param {string} id Unique identifier of the case to permanently delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    deleteCaseRaw(requestParameters: DeleteCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * **PERMANENTLY DELETES** a case and all related data. This is a **HARD DELETE** operation that:  • Completely removes the case from the database • Deletes ALL related events, entities, sources, feedback, and close reasons • Cannot be undone - the case and all associated data is permanently lost • Maintains audit trail of the deletion operation  **Warning**: This operation is irreversible. Consider exporting case data before deletion if needed for compliance or historical purposes.  **Related Data Deleted:** - All timeline events - All case entities (IOCs, indicators) - All case sources - All case feedback entries - Close reason (if exists)  **Security**: Requires `cases:remove` permission and MAC policy compliance. 
     * Permanently delete case
     */
    deleteCase(requestParameters: DeleteCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Deletes a specific event from a case with field-level permission validation
     * @summary Delete case event
     * @param {string} caseId Case ID
     * @param {string} eventId Event ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    deleteCaseEventRaw(requestParameters: DeleteCaseEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Deletes a specific event from a case with field-level permission validation
     * Delete case event
     */
    deleteCaseEvent(requestParameters: DeleteCaseEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Deletes feedback for a case with field-level permission validation
     * @summary Delete case feedback
     * @param {string} caseId Case ID
     * @param {string} feedbackId Feedback ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    deleteCaseFeedbackRaw(requestParameters: DeleteCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Deletes feedback for a case with field-level permission validation
     * Delete case feedback
     */
    deleteCaseFeedback(requestParameters: DeleteCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Escalates a case, marking it as escalated and changing status to ESCALATED
     * @summary Escalate case
     * @param {string} caseId Case ID
     * @param {string} [reason] Reason for escalation
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    escalateCaseRaw(requestParameters: EscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Escalates a case, marking it as escalated and changing status to ESCALATED
     * Escalate case
     */
    escalateCase(requestParameters: EscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Retrieves a specific case by ID with MAC policy enforcement
     * @summary Get case by ID
     * @param {string} id Case ID
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Access a case from a specific tenant when you\&#39;ve switched contexts.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCaseRaw(requestParameters: GetCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Retrieves a specific case by ID with MAC policy enforcement
     * Get case by ID
     */
    getCase(requestParameters: GetCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Retrieves all available case categories for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case categories that can be used to: - Populate dropdown menus in case creation forms - Filter case types by category - Understand the different types of cases the system supports - Build category-based navigation and reporting  **Case Categories:** The system supports the following case categories:  - **SECURITY_INCIDENT** - Security incidents, breaches, and threats - **VULNERABILITY** - Vulnerability management and scanning results - **COMPLIANCE** - Policy violations and regulatory compliance issues - **RISK_ASSESSMENT** - Risk analysis and assessment activities - **SUPPORT** - General support requests and inquiries - **THREAT_INTELLIGENCE** - Threat intelligence and analysis - **AUDIT** - Audit findings and compliance reviews - **GENERAL** - Miscellaneous cases that don\'t fit other categories  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Categories are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-categories?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch categories for dropdown const response = await fetch(\'/api/v1/cases/case-categories?sessionId=\' + sessionId); const categories = await response.json();  // Populate category dropdown categories.data.forEach(category => {     dropdown.addOption(category.category, category.displayName); }); ```  **React Component Example:** ```jsx const [categories, setCategories] = useState([]);  useEffect(() => {     fetchCategories(); }, []);  const fetchCategories = async () => {     const response = await api.get(\'/cases/case-categories\', {         params: { sessionId }     });     setCategories(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Categories are static and rarely change - Consider caching results on the frontend - Response is lightweight and fast 
     * @summary Get case categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCaseCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseCategoryListResponse>>;

    /**
     * Retrieves all available case categories for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case categories that can be used to: - Populate dropdown menus in case creation forms - Filter case types by category - Understand the different types of cases the system supports - Build category-based navigation and reporting  **Case Categories:** The system supports the following case categories:  - **SECURITY_INCIDENT** - Security incidents, breaches, and threats - **VULNERABILITY** - Vulnerability management and scanning results - **COMPLIANCE** - Policy violations and regulatory compliance issues - **RISK_ASSESSMENT** - Risk analysis and assessment activities - **SUPPORT** - General support requests and inquiries - **THREAT_INTELLIGENCE** - Threat intelligence and analysis - **AUDIT** - Audit findings and compliance reviews - **GENERAL** - Miscellaneous cases that don\'t fit other categories  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Categories are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-categories?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch categories for dropdown const response = await fetch(\'/api/v1/cases/case-categories?sessionId=\' + sessionId); const categories = await response.json();  // Populate category dropdown categories.data.forEach(category => {     dropdown.addOption(category.category, category.displayName); }); ```  **React Component Example:** ```jsx const [categories, setCategories] = useState([]);  useEffect(() => {     fetchCategories(); }, []);  const fetchCategories = async () => {     const response = await api.get(\'/cases/case-categories\', {         params: { sessionId }     });     setCategories(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Categories are static and rarely change - Consider caching results on the frontend - Response is lightweight and fast 
     * Get case categories
     */
    getCaseCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseCategoryListResponse>;

    /**
     * Retrieves all feedback for a case
     * @summary Get case feedback
     * @param {string} id Case ID
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Get feedback for a case from a specific tenant context.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCaseFeedbackRaw(requestParameters: GetCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Retrieves all feedback for a case
     * Get case feedback
     */
    getCaseFeedback(requestParameters: GetCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Retrieves aggregated case statistics with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    provides aggregated statistics from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the specified tenant IDs 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Provides statistics aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Statistics Included:** - Total case count - Cases by status (Open, In Progress, Resolved, etc.) - Cases by severity (Critical, High, Medium, Low) - Escalated cases count - Cases by tenant (for multi-tenant views) - Recent activity (last 30 days) - Tenant context information (selectedTenants, isMultiTenant)  **Security & Access Control:** - All statistics are filtered by Row Level Security (RLS) policies - User must have \'cases:read\' permission for the requested tenants - Access validation ensures user can only see statistics for authorized tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **Use Cases:** - Dashboard statistics based on user\'s tenant selection - Cross-tenant reporting and aggregation - Real-time statistics for selected tenant scope 
     * @summary Get case statistics with flexible tenant selection
     * @param {string} [tenantIds] **OVERRIDE PARAMETER - Optional tenant selection override**  **When NOT provided (DEFAULT BEHAVIOR):** - Uses &#x60;tenantIsolationService.getEffectiveTenantIds(sessionId)&#x60; - Returns selectedTenants from the user\&#39;s session - If no tenants selected in session, uses ALL_SELECTABLE_TENANTS (configurable)  **When provided (OVERRIDE BEHAVIOR):** - Ignores session tenant selection completely - Uses only the specified tenant IDs - Validates user has access to all requested tenants  **Format:** Comma-separated list of tenant IDs **Example:** &#x60;tenant-abc123,tenant-def456&#x60; **Validation:** All specified tenants must be in user\&#39;s authorized tenant list  **Use Cases:** - Default: &#x60;GET /api/v1/cases/statistics?sessionId&#x3D;abc123&#x60; (uses session selection) - Override: &#x60;GET /api/v1/cases/statistics?sessionId&#x3D;abc123&amp;tenantIds&#x3D;tenant1,tenant2&#x60; (ignores session)  **Statistics Impact:** - When not provided: Statistics reflect the user\&#39;s session tenant selection or all authorized tenants - When provided: Statistics are aggregated only from the specified tenants  **Note:** Tenant selection is now handled by @TenantSelection annotation with configurable behavior. 
     * @param {Date} [createdFrom] Filter statistics by cases created from this date (ISO 8601 format, e.g., 2024-01-01T00:00:00). When provided, statistics will only include cases created on or after this date.
     * @param {Date} [createdTo] Filter statistics by cases created up to this date (ISO 8601 format, e.g., 2024-01-31T23:59:59). When provided, statistics will only include cases created on or before this date.
     * @param {string} [severity] CSV list: CRITICAL,HIGH,MEDIUM,LOW,INFO
     * @param {string} [status] CSV list: OPEN,IN_PROGRESS,RESOLVED,ESCALATED
     * @param {string} [owner] CSV owner filter
     * @param {boolean} [escalated] Ever escalated filter (true|false)
     * @param {string} [search] Search term filter
     * @param {string} [id] Case ID filter
     * @param {string} [sourceId] Source ID filter
     * @param {string} [tenantId] Single tenant ID filter
     * @param {string} [tenantName] Tenant name filter
     * @param {Date} [updatedFrom] ISO-8601 UTC datetime
     * @param {Date} [updatedTo] ISO-8601 UTC datetime
     * @param {string} [entities] Entity search filter
     * @param {string} [events] Event search filter
     * @param {boolean} [matchCase] Case-sensitive search mode
     * @param {boolean} [wholeWord] Whole-word search mode
     * @param {boolean} [useRegex] Regex search mode
     * @param {string} [resolutionReasonValues] CSV disposition text filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCaseStatisticsRaw(requestParameters: GetCaseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Retrieves aggregated case statistics with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    provides aggregated statistics from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the specified tenant IDs 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Provides statistics aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Statistics Included:** - Total case count - Cases by status (Open, In Progress, Resolved, etc.) - Cases by severity (Critical, High, Medium, Low) - Escalated cases count - Cases by tenant (for multi-tenant views) - Recent activity (last 30 days) - Tenant context information (selectedTenants, isMultiTenant)  **Security & Access Control:** - All statistics are filtered by Row Level Security (RLS) policies - User must have \'cases:read\' permission for the requested tenants - Access validation ensures user can only see statistics for authorized tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **Use Cases:** - Dashboard statistics based on user\'s tenant selection - Cross-tenant reporting and aggregation - Real-time statistics for selected tenant scope 
     * Get case statistics with flexible tenant selection
     */
    getCaseStatistics(requestParameters: GetCaseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Retrieves all available case types for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case types that can be used to: - Populate case type selection in case creation forms - Understand the different types of cases the system supports - Build type-based filtering and reporting - Determine workflow configurations for different case types  **Case Types:** The system includes predefined case types across various categories:  **Security Incidents:** - MALWARE_DETECTION - Detection of malicious software or code - PHISHING_ATTEMPT - Suspicious email or website attempting to steal credentials - UNAUTHORIZED_ACCESS - Suspicious login or access attempt - DATA_EXFILTRATION - Suspicious data transfer or download activity - SOCIAL_ENGINEERING - Manipulation attempt to gain unauthorized access - INSIDER_THREAT - Suspicious activity from internal user - DDoS_ATTACK - Distributed denial of service attack - RANSOMWARE_ATTEMPT - Ransomware detection or attempt  **Other Categories:** - VULNERABILITY_SCAN - Automated vulnerability detection - COMPLIANCE_VIOLATION - Policy or regulatory compliance issue  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Case types are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-types?sessionId=abc123&page=1&pageSize=10 ```  **Frontend Integration:** ```javascript // Fetch case types for dropdown const response = await fetch(\'/api/v1/cases/case-types?sessionId=\' + sessionId); const caseTypes = await response.json();  // Populate case type dropdown caseTypes.data.forEach(caseType => {     dropdown.addOption(caseType.id, caseType.displayName); }); ```  **React Component Example:** ```jsx const [caseTypes, setCaseTypes] = useState([]);  useEffect(() => {     fetchCaseTypes(); }, []);  const fetchCaseTypes = async () => {     const response = await api.get(\'/cases/case-types\', {         params: { sessionId, page: 1, pageSize: 50 }     });     setCaseTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Supports pagination for large datasets 
     * @summary Get case types
     * @param {string} [page] Page number (1-based indexing)
     * @param {string} [pageSize] Number of items per page
     * @param {string} [sortBy] Field to sort by
     * @param {'asc' | 'desc'} [sortOrder] Sort order (asc or desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCaseTypesRaw(requestParameters: GetCaseTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>>;

    /**
     * Retrieves all available case types for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case types that can be used to: - Populate case type selection in case creation forms - Understand the different types of cases the system supports - Build type-based filtering and reporting - Determine workflow configurations for different case types  **Case Types:** The system includes predefined case types across various categories:  **Security Incidents:** - MALWARE_DETECTION - Detection of malicious software or code - PHISHING_ATTEMPT - Suspicious email or website attempting to steal credentials - UNAUTHORIZED_ACCESS - Suspicious login or access attempt - DATA_EXFILTRATION - Suspicious data transfer or download activity - SOCIAL_ENGINEERING - Manipulation attempt to gain unauthorized access - INSIDER_THREAT - Suspicious activity from internal user - DDoS_ATTACK - Distributed denial of service attack - RANSOMWARE_ATTEMPT - Ransomware detection or attempt  **Other Categories:** - VULNERABILITY_SCAN - Automated vulnerability detection - COMPLIANCE_VIOLATION - Policy or regulatory compliance issue  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Case types are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-types?sessionId=abc123&page=1&pageSize=10 ```  **Frontend Integration:** ```javascript // Fetch case types for dropdown const response = await fetch(\'/api/v1/cases/case-types?sessionId=\' + sessionId); const caseTypes = await response.json();  // Populate case type dropdown caseTypes.data.forEach(caseType => {     dropdown.addOption(caseType.id, caseType.displayName); }); ```  **React Component Example:** ```jsx const [caseTypes, setCaseTypes] = useState([]);  useEffect(() => {     fetchCaseTypes(); }, []);  const fetchCaseTypes = async () => {     const response = await api.get(\'/cases/case-types\', {         params: { sessionId, page: 1, pageSize: 50 }     });     setCaseTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Supports pagination for large datasets 
     * Get case types
     */
    getCaseTypes(requestParameters: GetCaseTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse>;

    /**
     * Retrieves case types filtered by category
     * @summary Get case types by category
     * @param {string} category Case category to filter by
     * @param {string} [pageParam] Page number
     * @param {string} [pageSizeParam] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCaseTypesByCategoryRaw(requestParameters: GetCaseTypesByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>>;

    /**
     * Retrieves case types filtered by category
     * Get case types by category
     */
    getCaseTypesByCategory(requestParameters: GetCaseTypesByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse>;

    /**
     * Retrieves case types filtered by category
     * @summary Get case types by category
     * @param {string} category Case category to filter by
     * @param {string} [pageParam] Page number
     * @param {string} [pageSizeParam] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCaseTypesByCategory1Raw(requestParameters: GetCaseTypesByCategory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>>;

    /**
     * Retrieves case types filtered by category
     * Get case types by category
     */
    getCaseTypesByCategory1(requestParameters: GetCaseTypesByCategory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse>;

    /**
     * Retrieves a paginated list of security cases with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns cases from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns cases aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Security & Access Control:** - All cases are filtered by Row Level Security (RLS) policies - MAC (Mandatory Access Control) policies are enforced for individual case access - User must have \'cases:read\' permission for the requested tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **With Pagination:** - `GET /api/v1/cases?sessionId=abc123&page=2&pageSize=20`   → Uses session selection with pagination 
     * @summary Get cases with flexible tenant selection
     * @param {string} [tenantIds] **OVERRIDE PARAMETER - Optional tenant selection override**  **When NOT provided (DEFAULT BEHAVIOR):** - Uses &#x60;tenantIsolationService.getEffectiveTenantIds(sessionId)&#x60; - Returns selectedTenants from the user\&#39;s session - If no tenants selected in session, uses ALL_SELECTABLE_TENANTS (configurable)  **When provided (OVERRIDE BEHAVIOR):** - Ignores session tenant selection completely - Uses only the specified tenant IDs - Validates user has access to all requested tenants  **Format:** Comma-separated list of tenant IDs **Example:** &#x60;tenant-abc123,tenant-def456&#x60; **Validation:** All specified tenants must be in user\&#39;s authorized tenant list  **Use Cases:** - Default: &#x60;GET /api/v1/cases?sessionId&#x3D;abc123&#x60; (uses session selection) - Override: &#x60;GET /api/v1/cases?sessionId&#x3D;abc123&amp;tenantIds&#x3D;tenant1,tenant2&#x60; (ignores session)  **Note:** Tenant selection is now handled by @TenantSelection annotation with configurable behavior. 
     * @param {string} [page] Page number (1-based indexing)
     * @param {string} [pageSize] Number of cases per page (max 100)
     * @param {boolean} [includeCollections] **Optional parameter to include collections (events, entities, sources)**  **Default:** &#x60;false&#x60; (for performance - collections are not loaded)  **When &#x60;true&#x60;:** - Eagerly fetches events, entities, and sources using JOIN FETCH - Avoids N+1 query problems by loading all data in efficient queries - Returns complete case data including all nested collections - Useful for external integrations (e.g., XSOAR) that need full case data  **When &#x60;false&#x60; (default):** - Collections are not loaded, improving performance for list views - Use this for UI table views where collections are not needed  **Performance Note:** - When &#x60;includeCollections&#x3D;true&#x60;, the query uses a two-step approach:   1. First fetches case IDs with pagination (fast)   2. Then fetches full cases with collections using JOIN FETCH (efficient, no N+1) - This approach maintains good performance even with collections  **Example:** - &#x60;GET /api/v1/cases?sessionId&#x3D;abc123&#x60; (collections not included - fast) - &#x60;GET /api/v1/cases?sessionId&#x3D;abc123&amp;includeCollections&#x3D;true&#x60; (collections included - complete data) 
     * @param {string} [include] Collection include selector (preferred over includeCollections). CSV values: events, entities, sources, feedback. Example: include&#x3D;sources or include&#x3D;events,entities 
     * @param {string} [severity] Filter by severities (csv)
     * @param {string} [status] Filter by statuses (csv)
     * @param {string} [owner] Filter by owners (csv)
     * @param {boolean} [escalated] When combined with &#x60;status&#x60; (or any status filter), filters on the case &#x60;escalated&#x60; boolean column (true/false). When &#x60;status&#x60; is omitted: legacy behavior — &#x60;true&#x60; restricts to workflow status ESCALATED only; &#x60;false&#x60; to OPEN, IN_PROGRESS, RESOLVED (boolean column is not applied in that path). 
     * @param {string} [excludedCaseIds] Optional comma-separated case IDs to exclude from result rows by exact &#x60;case.id&#x60; match. Blank segments are ignored and duplicate IDs are deduplicated. Unknown IDs are a no-op. Maximum 200 IDs; maximum 128 characters per ID. 
     * @param {string} [resolutionReasonValues] Optional disposition filter: comma-separated needles aligned with widget &#x60;resolutionReasonValues&#x60;. Each value is matched case-insensitively as a substring of &#x60;close_reason.description&#x60; (OR across values). Blank segments after split are ignored; if nothing remains, the filter is not applied. Commas inside a single value are not supported (use repeated query params or JSON list where applicable). Maximum 32 values; each value max 256 characters. If this filter is non-empty and &#x60;status&#x60; is also specified, &#x60;status&#x60; must include &#x60;RESOLVED&#x60; (otherwise 400). If &#x60;status&#x60; is omitted (all statuses), no 400; non-resolved cases simply do not match the disposition predicate. 
     * @param {string} [search] Search by name/summary (case-insensitive)
     * @param {string} [sourceId] Identifier of the source system the case was generated from (supports partial match, case-insensitive)
     * @param {string} [sourceTechnology] Filter by source technology (csv exact match, case-insensitive) against case sources
     * @param {string} [id] Filter by case ID (supports partial match, case-insensitive)
     * @param {string} [type] Filter by case type ID
     * @param {string} [tenantId] Filter by tenantId (RLS applies; usually ignored unless override path)
     * @param {string} [tenantName] Filter by tenant name (comma-separated list, case-insensitive partial match). Looks up tenant IDs by name and filters cases to those tenants. Only tenants within the user\&#39;s authorized tenants are considered.
     * @param {Date} [createdFrom] Created from (ISO)
     * @param {Date} [createdTo] Created to (ISO)
     * @param {Date} [updatedFrom] Updated from (ISO)
     * @param {Date} [updatedTo] Updated to (ISO)
     * @param {string} [entities] Filter cases by entities (type or value; free-text)
     * @param {string} [events] Filter cases by events (type or content; free-text)
     * @param {boolean} [matchCase] Case-sensitive matches for text filters (search/entities/events)
     * @param {boolean} [wholeWord] Whole-word matches for text filters (search/entities/events)
     * @param {boolean} [useRegex] Treat text filters (search/entities/events) as regex (validated)
     * @param {string} [sortBy] Sort field
     * @param {'asc' | 'desc'} [sortOrder] Sort order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCasesRaw(requestParameters: GetCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseListResponse>>;

    /**
     * Retrieves a paginated list of security cases with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns cases from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns cases aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Security & Access Control:** - All cases are filtered by Row Level Security (RLS) policies - MAC (Mandatory Access Control) policies are enforced for individual case access - User must have \'cases:read\' permission for the requested tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **With Pagination:** - `GET /api/v1/cases?sessionId=abc123&page=2&pageSize=20`   → Uses session selection with pagination 
     * Get cases with flexible tenant selection
     */
    getCases(requestParameters: GetCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseListResponse>;

    /**
     * Retrieves case types that the current user has permission to create.  **Purpose:** This endpoint provides a filtered list of case types based on the user\'s permissions. It\'s used to populate case creation forms with only the case types the user can create.  **Field-Level Permission Integration:** The response is filtered based on the user\'s case type creation permissions: - **cases:create:security_incident** - Can create security incident cases - **cases:create:vulnerability** - Can create vulnerability cases - **cases:create:compliance** - Can create compliance cases - **cases:create:risk_assessment** - Can create risk assessment cases - **cases:create:support** - Can create support cases - **cases:create:threat_intelligence** - Can create threat intelligence cases - **cases:create:audit** - Can create audit cases - **cases:create:general** - Can create general cases - **cases:create:all** - Can create all case types  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Response is filtered based on user\'s field-level permissions  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/creatable-types?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch creatable case types for dropdown const response = await fetch(\'/api/v1/cases/creatable-types?sessionId=\' + sessionId); const creatableTypes = await response.json();  // Populate case type dropdown with only allowed types creatableTypes.data.forEach(caseType => {     dropdown.addOption(caseType.typeCode, caseType.displayName); }); ```  **React Component Example:** ```jsx const [creatableTypes, setCreatableTypes] = useState([]);  useEffect(() => {     fetchCreatableTypes(); }, []);  const fetchCreatableTypes = async () => {     const response = await api.get(\'/cases/creatable-types\', {         params: { sessionId }     });     setCreatableTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Response is filtered based on permissions, so it\'s always relevant 
     * @summary Get creatable case types
     * @param {string} [page] Page number (1-based indexing)
     * @param {string} [pageSize] Number of items per page
     * @param {string} [sortBy] Field to sort by
     * @param {'asc' | 'desc'} [sortOrder] Sort order (asc or desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getCreatableCaseTypes1Raw(requestParameters: GetCreatableCaseTypes1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>>;

    /**
     * Retrieves case types that the current user has permission to create.  **Purpose:** This endpoint provides a filtered list of case types based on the user\'s permissions. It\'s used to populate case creation forms with only the case types the user can create.  **Field-Level Permission Integration:** The response is filtered based on the user\'s case type creation permissions: - **cases:create:security_incident** - Can create security incident cases - **cases:create:vulnerability** - Can create vulnerability cases - **cases:create:compliance** - Can create compliance cases - **cases:create:risk_assessment** - Can create risk assessment cases - **cases:create:support** - Can create support cases - **cases:create:threat_intelligence** - Can create threat intelligence cases - **cases:create:audit** - Can create audit cases - **cases:create:general** - Can create general cases - **cases:create:all** - Can create all case types  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Response is filtered based on user\'s field-level permissions  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/creatable-types?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch creatable case types for dropdown const response = await fetch(\'/api/v1/cases/creatable-types?sessionId=\' + sessionId); const creatableTypes = await response.json();  // Populate case type dropdown with only allowed types creatableTypes.data.forEach(caseType => {     dropdown.addOption(caseType.typeCode, caseType.displayName); }); ```  **React Component Example:** ```jsx const [creatableTypes, setCreatableTypes] = useState([]);  useEffect(() => {     fetchCreatableTypes(); }, []);  const fetchCreatableTypes = async () => {     const response = await api.get(\'/cases/creatable-types\', {         params: { sessionId }     });     setCreatableTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Response is filtered based on permissions, so it\'s always relevant 
     * Get creatable case types
     */
    getCreatableCaseTypes1(requestParameters: GetCreatableCaseTypes1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse>;

    /**
     * Returns resolved-case SLA aggregates grouped by user-local calendar day and severity. Fields `mtta`, `mttn`, `mttc`, and `mttd` under each severity node are **mean whole minutes** (rounded from per-case SLA timers stored in **seconds** on `security_case`), aligned with POST `/v1/cases/mttx-metrics-graph` widget duration semantics (Minutes). 
     * @summary MTTX graph metrics by day and severity
     * @param {string} lookback lookback
     * @param {string} [tenantIds] **OVERRIDE PARAMETER - Optional tenant selection override**  **When NOT provided (DEFAULT BEHAVIOR):** - Uses &#x60;tenantIsolationService.getEffectiveTenantIds(sessionId)&#x60; - Returns selectedTenants from the user\&#39;s session - If no tenants selected in session, uses ALL_SELECTABLE_TENANTS (configurable)  **When provided (OVERRIDE BEHAVIOR):** - Ignores session tenant selection completely - Uses only the specified tenant IDs - Validates user has access to all requested tenants  **Format:** Comma-separated list of tenant IDs **Example:** &#x60;tenant-abc123,tenant-def456&#x60; **Validation:** All specified tenants must be in user\&#39;s authorized tenant list  **Note:** Tenant selection is now handled by @TenantSelection annotation with configurable behavior. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getMttxGraphMetricsRaw(requestParameters: GetMttxGraphMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MttxMetricsGraphResponse>>;

    /**
     * Returns resolved-case SLA aggregates grouped by user-local calendar day and severity. Fields `mtta`, `mttn`, `mttc`, and `mttd` under each severity node are **mean whole minutes** (rounded from per-case SLA timers stored in **seconds** on `security_case`), aligned with POST `/v1/cases/mttx-metrics-graph` widget duration semantics (Minutes). 
     * MTTX graph metrics by day and severity
     */
    getMttxGraphMetrics(requestParameters: GetMttxGraphMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MttxMetricsGraphResponse>;

    /**
     * Retrieves cases related to a specific case
     * @summary Get related cases
     * @param {string} id Case ID
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Access related cases from a specific tenant context.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    getRelatedCasesRaw(requestParameters: GetRelatedCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseListResponse>>;

    /**
     * Retrieves cases related to a specific case
     * Get related cases
     */
    getRelatedCases(requestParameters: GetRelatedCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseListResponse>;

    /**
     * Aggregated metrics for Security Dashboard widgets (time series, donut, KPI). Uses the same tenant and session context as GET /mttx-metrics-graph. Table widgets must use GET /cases with the same UTC bounds as queryTimeRangeUtc in the response.  **Time series (chartType line, bar, or area):** Successful responses use kind `series`, include `points` (each `SeriesGraphPoint` uses uppercase severity keys CRITICAL, HIGH, MEDIUM, LOW, INFO on the wire), and include camelCase `xAxisLabel` and `yAxisLabel`. `yAxisLabel` is `Minutes` for mtta, mttn, mttc, and mttd (values are mean minutes per day and severity bucket) and `Totals` for caseCount. `xAxisLabel` summarizes the same local calendar day range used to build points, aligned with `queryTimeRangeUtc` (inclusive UTC `created` bounds). Line, bar, and area share the same axis semantics.  **Donut and KPI:** Axis label fields are not populated (null). Clients may fall back to local defaults. KPI responses include `value`, `displayMode` (`scalar` or `duration`), and `trendPercent` (percent change vs an immediately preceding period of equal UTC length with the same widget filters).  **Donut close reason metrics** (`donut_incidents_by_close_reason`, `donut_escalated_cases_by_disposition`): each segment `name` is the resolved case\'s `close_reason.description` text (aggregated per distinct description). Blank descriptions are grouped as `Unspecified`.  **Donut incidents by severity** (`donut_incidents_by_severity`): optional `widgetOptions.caseListFilters.escalation` of `escalated` or `nonEscalated` restricts counts to cases with that boolean `escalated` value in the `created` window; omitted or `all` includes all cases (same window and exclusions as other donuts).  **Preset date range:** when `dateRange.mode` is preset, `dateRange.days` uses the same UTC window and inclusive-end `created` bounds as GET `/v1/cases/mttx-metrics-graph` with `lookback` set to the same number. Custom `from`/`to` ranges remain full local civil days in the user\'s zone with an inclusive UTC end. 
     * @summary Security Dashboard widget metrics
     * @param {SecurityWidgetQueryRequest} securityWidgetQueryRequest 
     * @param {string} [tenantIds] Optional tenant override (comma-separated), same semantics as GET /mttx-metrics-graph
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    postSecurityWidgetMetricsRaw(requestParameters: PostSecurityWidgetMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityWidgetMetricsResponse>>;

    /**
     * Aggregated metrics for Security Dashboard widgets (time series, donut, KPI). Uses the same tenant and session context as GET /mttx-metrics-graph. Table widgets must use GET /cases with the same UTC bounds as queryTimeRangeUtc in the response.  **Time series (chartType line, bar, or area):** Successful responses use kind `series`, include `points` (each `SeriesGraphPoint` uses uppercase severity keys CRITICAL, HIGH, MEDIUM, LOW, INFO on the wire), and include camelCase `xAxisLabel` and `yAxisLabel`. `yAxisLabel` is `Minutes` for mtta, mttn, mttc, and mttd (values are mean minutes per day and severity bucket) and `Totals` for caseCount. `xAxisLabel` summarizes the same local calendar day range used to build points, aligned with `queryTimeRangeUtc` (inclusive UTC `created` bounds). Line, bar, and area share the same axis semantics.  **Donut and KPI:** Axis label fields are not populated (null). Clients may fall back to local defaults. KPI responses include `value`, `displayMode` (`scalar` or `duration`), and `trendPercent` (percent change vs an immediately preceding period of equal UTC length with the same widget filters).  **Donut close reason metrics** (`donut_incidents_by_close_reason`, `donut_escalated_cases_by_disposition`): each segment `name` is the resolved case\'s `close_reason.description` text (aggregated per distinct description). Blank descriptions are grouped as `Unspecified`.  **Donut incidents by severity** (`donut_incidents_by_severity`): optional `widgetOptions.caseListFilters.escalation` of `escalated` or `nonEscalated` restricts counts to cases with that boolean `escalated` value in the `created` window; omitted or `all` includes all cases (same window and exclusions as other donuts).  **Preset date range:** when `dateRange.mode` is preset, `dateRange.days` uses the same UTC window and inclusive-end `created` bounds as GET `/v1/cases/mttx-metrics-graph` with `lookback` set to the same number. Custom `from`/`to` ranges remain full local civil days in the user\'s zone with an inclusive UTC end. 
     * Security Dashboard widget metrics
     */
    postSecurityWidgetMetrics(requestParameters: PostSecurityWidgetMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityWidgetMetricsResponse>;

    /**
     * POST equivalent of GET /v1/cases/statistics with the same filter semantics.
     * @summary Filtered case statistics query
     * @param {CaseStatisticsQueryRequest} caseStatisticsQueryRequest 
     * @param {string} [tenantIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    queryCaseStatisticsRaw(requestParameters: QueryCaseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * POST equivalent of GET /v1/cases/statistics with the same filter semantics.
     * Filtered case statistics query
     */
    queryCaseStatistics(requestParameters: QueryCaseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Removes a specific custom field from a case. This endpoint allows granular removal of individual custom fields without affecting other custom fields.  **Features:** - Removes a single custom field by key - Preserves all other existing custom fields - Maintains audit trail of removal - Returns error if field doesn\'t exist  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Removal is automatically associated with the case\'s tenant 
     * @summary Remove a custom field from a case
     * @param {string} caseId Case ID
     * @param {string} fieldKey Custom field key to remove
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    removeCaseCustomFieldRaw(requestParameters: RemoveCaseCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Removes a specific custom field from a case. This endpoint allows granular removal of individual custom fields without affecting other custom fields.  **Features:** - Removes a single custom field by key - Preserves all other existing custom fields - Maintains audit trail of removal - Returns error if field doesn\'t exist  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Removal is automatically associated with the case\'s tenant 
     * Remove a custom field from a case
     */
    removeCaseCustomField(requestParameters: RemoveCaseCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Reopens a previously resolved case with field-level permission validation
     * @summary Reopen case
     * @param {string} id Case ID
     * @param {string} reason Reopen reason
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Reopen a case from a specific tenant context.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    reopenCaseRaw(requestParameters: ReopenCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Reopens a previously resolved case with field-level permission validation
     * Reopen case
     */
    reopenCase(requestParameters: ReopenCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Resolves a case with specified reason and close rationale with field-level permission validation.  **Purpose:** This endpoint marks a case as resolved, indicating that the security incident has been fully investigated and remediated with appropriate actions taken.  **Status Change:** - Sets case status to RESOLVED - Records close reason and rationale - Creates timeline event for resolution - Maintains audit trail of resolution  **Field-Level Permissions:** - Requires cases:update:status or cases:update:all - Status changes require appropriate field-level permissions  **Request Body:** - closeReason: Structured close reason with category and subcategory - closeRationale: Detailed explanation of why the case was resolved - feedback: Optional feedback about the case handling process  **Security & Access Control:** - Requires \'cases:update\' permission - Field-level permissions are validated for status changes - Supports tenant isolation through session context - All resolution actions are audited for compliance  **Usage Examples:**  **Basic Resolution:** ```json {   \"closeReason\": {     \"category\": \"confirmed_threat\",     \"subCategory\": \"rule_logic_error\",     \"description\": \"Threat confirmed and contained\"   },   \"closeRationale\": \"Malware was successfully removed from affected systems\",   \"feedback\": \"Good response time and containment\" } ```  **False Positive Resolution:** ```json {   \"closeReason\": {     \"category\": \"legitimate_activity\",     \"subCategory\": \"known_system_behavior\",     \"description\": \"False positive - legitimate user activity\"   },   \"closeRationale\": \"User was performing authorized testing\",   \"feedback\": null } ``` 
     * @summary Resolve case
     * @param {string} id Case ID
     * @param {CloseCaseRequest} closeCaseRequest 
     * @param {string} [tenantIds] Comma-separated list of tenant IDs to override session tenant selection.  **Use Case:** Resolve a case from a specific tenant context.  **Example:** &#x60;tenantIds&#x3D;f38c4e40-51a1-4b84-a3b4-5c08446adf32&#x60;  If not provided, uses the session\&#39;s current tenant context. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    resolveCaseRaw(requestParameters: ResolveCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Resolves a case with specified reason and close rationale with field-level permission validation.  **Purpose:** This endpoint marks a case as resolved, indicating that the security incident has been fully investigated and remediated with appropriate actions taken.  **Status Change:** - Sets case status to RESOLVED - Records close reason and rationale - Creates timeline event for resolution - Maintains audit trail of resolution  **Field-Level Permissions:** - Requires cases:update:status or cases:update:all - Status changes require appropriate field-level permissions  **Request Body:** - closeReason: Structured close reason with category and subcategory - closeRationale: Detailed explanation of why the case was resolved - feedback: Optional feedback about the case handling process  **Security & Access Control:** - Requires \'cases:update\' permission - Field-level permissions are validated for status changes - Supports tenant isolation through session context - All resolution actions are audited for compliance  **Usage Examples:**  **Basic Resolution:** ```json {   \"closeReason\": {     \"category\": \"confirmed_threat\",     \"subCategory\": \"rule_logic_error\",     \"description\": \"Threat confirmed and contained\"   },   \"closeRationale\": \"Malware was successfully removed from affected systems\",   \"feedback\": \"Good response time and containment\" } ```  **False Positive Resolution:** ```json {   \"closeReason\": {     \"category\": \"legitimate_activity\",     \"subCategory\": \"known_system_behavior\",     \"description\": \"False positive - legitimate user activity\"   },   \"closeRationale\": \"User was performing authorized testing\",   \"feedback\": null } ``` 
     * Resolve case
     */
    resolveCase(requestParameters: ResolveCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Sets or updates a single custom field value for a case. This endpoint allows granular control over individual custom fields without affecting other custom fields.  **Features:** - Sets or updates a single custom field - Preserves all other existing custom fields - Supports any JSON data type - Maintains audit trail  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Field is automatically associated with the case\'s tenant 
     * @summary Set a single custom field value
     * @param {string} caseId Case ID
     * @param {string} fieldKey Custom field key
     * @param {CustomFieldValueRequest} customFieldValueRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    setCustomFieldRaw(requestParameters: SetCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Sets or updates a single custom field value for a case. This endpoint allows granular control over individual custom fields without affecting other custom fields.  **Features:** - Sets or updates a single custom field - Preserves all other existing custom fields - Supports any JSON data type - Maintains audit trail  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Field is automatically associated with the case\'s tenant 
     * Set a single custom field value
     */
    setCustomField(requestParameters: SetCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Removes the current assignment from a case, making it unassigned
     * @summary Unassign case
     * @param {string} caseId Case ID
     * @param {string} [reason] Reason for unassignment
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    unassignCaseRaw(requestParameters: UnassignCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Removes the current assignment from a case, making it unassigned
     * Unassign case
     */
    unassignCase(requestParameters: UnassignCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Updates an existing case with field-level permission validation.  **Updatable Fields:** - `name`: Case name/title - `summary`: Detailed case description - `severity`: Case severity level - `status`: Case status - `owner`: Case owner/assignee - `escalated`: Whether the case has been escalated - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:update permission - Different field-level permissions for different update types - Status changes require cases:update:status or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions 
     * @summary Update case
     * @param {string} id Case ID to update
     * @param {UpdateCaseRequest} updateCaseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    updateCaseRaw(requestParameters: UpdateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Updates an existing case with field-level permission validation.  **Updatable Fields:** - `name`: Case name/title - `summary`: Detailed case description - `severity`: Case severity level - `status`: Case status - `owner`: Case owner/assignee - `escalated`: Whether the case has been escalated - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:update permission - Different field-level permissions for different update types - Status changes require cases:update:status or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions 
     * Update case
     */
    updateCase(requestParameters: UpdateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Updates an existing case type with field-level permission validation.  **Updatable Fields:** - `displayName`: Display name of the case type - `description`: Description of the case type - `defaultSeverity`: Default severity level for cases of this type - `workflowConfig`: Workflow configuration (auto-assignment, escalation rules, SLA hours) - `requiredFields`: Required fields configuration for case creation - `isActive`: Whether the case type is active and available for use  **Field-Level Permissions:** - Requires cases:update:configuration permission - Workflow configuration changes require cases:update:workflow or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions - Case types are system-wide and affect all tenants  **Workflow Configuration Examples:** ```json {   \"autoAssign\": true,   \"escalationRules\": [\"24h\", \"48h\", \"72h\"],   \"slaHours\": 24,   \"notificationChannels\": [\"email\", \"slack\"],   \"approvalRequired\": false } ```  **Required Fields Configuration Examples:** ```json {   \"name\": \"required\",   \"summary\": \"required\",   \"severity\": \"optional\",   \"owner\": \"optional\",   \"custom_fields\": {     \"affected_systems\": \"required\",     \"threat_family\": \"optional\"   } } ``` 
     * @summary Update case type
     * @param {string} id Case type ID to update
     * @param {UpdateCaseTypeRequest} updateCaseTypeRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    updateCaseTypeRaw(requestParameters: UpdateCaseTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeResponse>>;

    /**
     * Updates an existing case type with field-level permission validation.  **Updatable Fields:** - `displayName`: Display name of the case type - `description`: Description of the case type - `defaultSeverity`: Default severity level for cases of this type - `workflowConfig`: Workflow configuration (auto-assignment, escalation rules, SLA hours) - `requiredFields`: Required fields configuration for case creation - `isActive`: Whether the case type is active and available for use  **Field-Level Permissions:** - Requires cases:update:configuration permission - Workflow configuration changes require cases:update:workflow or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions - Case types are system-wide and affect all tenants  **Workflow Configuration Examples:** ```json {   \"autoAssign\": true,   \"escalationRules\": [\"24h\", \"48h\", \"72h\"],   \"slaHours\": 24,   \"notificationChannels\": [\"email\", \"slack\"],   \"approvalRequired\": false } ```  **Required Fields Configuration Examples:** ```json {   \"name\": \"required\",   \"summary\": \"required\",   \"severity\": \"optional\",   \"owner\": \"optional\",   \"custom_fields\": {     \"affected_systems\": \"required\",     \"threat_family\": \"optional\"   } } ``` 
     * Update case type
     */
    updateCaseType(requestParameters: UpdateCaseTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeResponse>;

    /**
     * Updates custom fields for an existing case. Custom fields provide flexible storage for case-specific metadata that doesn\'t fit into standard case fields.  **Custom Fields Features:** - Support for any JSON data type (strings, numbers, booleans, arrays, objects) - Flexible key-value storage - Overwrites existing custom fields with the provided data - Maintains audit trail of all changes  **Use Cases:** - Department-specific metadata - Integration with external systems - Custom workflow data - Additional categorization - Compliance tracking fields  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Custom fields are automatically associated with the case\'s tenant 
     * @summary Update custom fields for a case
     * @param {string} caseId Case ID
     * @param {CustomFieldRequest} customFieldRequest 
     * @param {string} [sessionId] Session ID for tenant isolation and authentication context
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    updateCustomFieldsRaw(requestParameters: UpdateCustomFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Updates custom fields for an existing case. Custom fields provide flexible storage for case-specific metadata that doesn\'t fit into standard case fields.  **Custom Fields Features:** - Support for any JSON data type (strings, numbers, booleans, arrays, objects) - Flexible key-value storage - Overwrites existing custom fields with the provided data - Maintains audit trail of all changes  **Use Cases:** - Department-specific metadata - Integration with external systems - Custom workflow data - Additional categorization - Compliance tracking fields  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Custom fields are automatically associated with the case\'s tenant 
     * Update custom fields for a case
     */
    updateCustomFields(requestParameters: UpdateCustomFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

    /**
     * Updates a specific event within a case with field-level permission validation. This unified endpoint handles all event types:  **Supported Event Types:** - **Notes** (`note`): Updates the note content directly (requires cases:update:notes) - **Feedback** (`feedback`, `case_feedback`): Updates the underlying feedback entity and regenerates event content (requires events:create:feedback) - **Other Events**: Updates event content directly (requires cases:update:all)  **For Feedback Events:** - Extracts the feedback ID from event metadata - Updates the underlying CaseFeedback entity using structured data - Supports full feedback updates (rating, comment, feedbackType, metadata) - Regenerates the event content to reflect changes - Maintains the same response format (updated case with events)  **For Other Events:** - Updates the event content directly - Preserves existing event structure  **Field-Level Permissions:** - Note events: cases:update:notes or cases:update:all - Feedback events: events:create:feedback or cases:update:all - Other events: cases:update:all  **Request Body Format:** - For notes: `{\"content\": \"Updated note text\"}` - For feedback: `{\"comment\": \"Updated comment\", \"rating\": \"THUMBS_UP\", \"feedbackType\": \"CASE_FEEDBACK\"}` - For other events: `{\"content\": \"Updated content\"}`  **Response Format:** Always returns the updated case with the complete events array, ensuring consistency regardless of event type being updated.  **Benefits:** - Unified API for all timeline updates - No need for frontend to know about feedback IDs - Consistent response format - Clean, unambiguous design - Field-level permission validation 
     * @summary Update case event
     * @param {string} caseId Case ID
     * @param {string} eventId Event ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasesApiInterface
     */
    updateEventRaw(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>>;

    /**
     * Updates a specific event within a case with field-level permission validation. This unified endpoint handles all event types:  **Supported Event Types:** - **Notes** (`note`): Updates the note content directly (requires cases:update:notes) - **Feedback** (`feedback`, `case_feedback`): Updates the underlying feedback entity and regenerates event content (requires events:create:feedback) - **Other Events**: Updates event content directly (requires cases:update:all)  **For Feedback Events:** - Extracts the feedback ID from event metadata - Updates the underlying CaseFeedback entity using structured data - Supports full feedback updates (rating, comment, feedbackType, metadata) - Regenerates the event content to reflect changes - Maintains the same response format (updated case with events)  **For Other Events:** - Updates the event content directly - Preserves existing event structure  **Field-Level Permissions:** - Note events: cases:update:notes or cases:update:all - Feedback events: events:create:feedback or cases:update:all - Other events: cases:update:all  **Request Body Format:** - For notes: `{\"content\": \"Updated note text\"}` - For feedback: `{\"comment\": \"Updated comment\", \"rating\": \"THUMBS_UP\", \"feedbackType\": \"CASE_FEEDBACK\"}` - For other events: `{\"content\": \"Updated content\"}`  **Response Format:** Always returns the updated case with the complete events array, ensuring consistency regardless of event type being updated.  **Benefits:** - Unified API for all timeline updates - No need for frontend to know about feedback IDs - Consistent response format - Clean, unambiguous design - Field-level permission validation 
     * Update case event
     */
    updateEvent(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse>;

}

/**
 * 
 */
export class CasesApi extends runtime.BaseAPI implements CasesApiInterface {

    /**
     * Adds one or more entities to an existing case.  **Entity Types:** - `HOST`: Hostname, IP address, or system identifier - `USER`: Username, email, or user identifier - `FILE`: File path, hash, or file identifier - `PROCESS`: Process name, PID, or process identifier - `NETWORK`: Network address, port, or connection identifier - `DOMAIN`: Domain name or URL - `EMAIL`: Email address or email identifier - `CUSTOM`: Custom entity type  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Entities are automatically associated with the case\'s tenant 
     * Add entities to case
     */
    async addEntityToCaseRaw(requestParameters: AddEntityToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling addEntityToCase().'
            );
        }

        if (requestParameters['createCaseEntityRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseEntityRequest',
                'Required parameter "createCaseEntityRequest" was null or undefined when calling addEntityToCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/entities`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createCaseEntityRequest']!.map(CreateCaseEntityRequestToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Adds one or more entities to an existing case.  **Entity Types:** - `HOST`: Hostname, IP address, or system identifier - `USER`: Username, email, or user identifier - `FILE`: File path, hash, or file identifier - `PROCESS`: Process name, PID, or process identifier - `NETWORK`: Network address, port, or connection identifier - `DOMAIN`: Domain name or URL - `EMAIL`: Email address or email identifier - `CUSTOM`: Custom entity type  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Entities are automatically associated with the case\'s tenant 
     * Add entities to case
     */
    async addEntityToCase(requestParameters: AddEntityToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.addEntityToCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new event to an existing case.  **Event Types:** - `note`: General notes or comments - `case_created`: Case creation event - `case_assigned`: Case assignment event - `case_escalated`: Case escalation event - `case_closed`: Case closure event - `case_reopened`: Case reopening event - `case_feedback`: Case feedback event - `case_resolved`: Case resolution event - `status_change`: Status change event - `feedback`: General feedback event - `case_updated`: Case update event - `case_owner_changed`: Owner change event - `case_severity_changed`: Severity change event - `case_escalation_cleared`: Escalation cleared event - `comment`: Comment event - `EVIDENCE`: Evidence collection event - `INVESTIGATION`: Investigation event - `ANALYSIS`: Analysis event - `RESPONSE`: Response event  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Event is automatically associated with the case\'s tenant 
     * Add event to case
     */
    async addEventToCaseRaw(requestParameters: AddEventToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling addEventToCase().'
            );
        }

        if (requestParameters['createCaseEventRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseEventRequest',
                'Required parameter "createCaseEventRequest" was null or undefined when calling addEventToCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/events`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseEventRequestToJSON(requestParameters['createCaseEventRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Adds a new event to an existing case.  **Event Types:** - `note`: General notes or comments - `case_created`: Case creation event - `case_assigned`: Case assignment event - `case_escalated`: Case escalation event - `case_closed`: Case closure event - `case_reopened`: Case reopening event - `case_feedback`: Case feedback event - `case_resolved`: Case resolution event - `status_change`: Status change event - `feedback`: General feedback event - `case_updated`: Case update event - `case_owner_changed`: Owner change event - `case_severity_changed`: Severity change event - `case_escalation_cleared`: Escalation cleared event - `comment`: Comment event - `EVIDENCE`: Evidence collection event - `INVESTIGATION`: Investigation event - `ANALYSIS`: Analysis event - `RESPONSE`: Response event  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Event is automatically associated with the case\'s tenant 
     * Add event to case
     */
    async addEventToCase(requestParameters: AddEventToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.addEventToCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submits feedback for a case with field-level permission validation
     * Submit case feedback
     */
    async addFeedbackRaw(requestParameters: AddFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addFeedback().'
            );
        }

        if (requestParameters['feedback'] == null) {
            throw new runtime.RequiredError(
                'feedback',
                'Required parameter "feedback" was null or undefined when calling addFeedback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['feedback'] != null) {
            queryParameters['feedback'] = requestParameters['feedback'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{id}/feedback`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Submits feedback for a case with field-level permission validation
     * Submit case feedback
     */
    async addFeedback(requestParameters: AddFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.addFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a note to an existing case with field-level permission validation
     * Add note to case
     */
    async addNoteRaw(requestParameters: AddNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addNote().'
            );
        }

        if (requestParameters['content'] == null) {
            throw new runtime.RequiredError(
                'content',
                'Required parameter "content" was null or undefined when calling addNote().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['content'] != null) {
            queryParameters['content'] = requestParameters['content'];
        }

        if (requestParameters['noteType'] != null) {
            queryParameters['noteType'] = requestParameters['noteType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{id}/notes`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Adds a note to an existing case with field-level permission validation
     * Add note to case
     */
    async addNote(requestParameters: AddNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.addNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new source to an existing case.  **Source Technologies:** - `MSFT_XDR`: Microsoft XDR - `PALO_ALTO_XDR`: Palo Alto XDR - `PALO_ALTO_XSOAR`: Palo Alto XSOAR - `MSFT_SENTINEL`: Microsoft Sentinel - `CROWDSTRIKE`: CrowdStrike Falcon - `SENTINELONE`: SentinelOne - `SPLUNK`: Splunk - `QRADAR`: IBM QRadar - `NESSUS`: Tenable Nessus - `QUALYS`: Qualys - `RAPID7`: Rapid7 - `RSA_ARCHER`: RSA Archer - `SERVICENOW`: ServiceNow - `ETL_PIPELINE`: ETL Pipeline - `WEB_APP`: Web Application - `EMAIL`: Email - `UNKNOWN`: Unknown  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Source is automatically associated with the case\'s tenant 
     * Add source to case
     */
    async addSourceToCaseRaw(requestParameters: AddSourceToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling addSourceToCase().'
            );
        }

        if (requestParameters['createCaseSourceRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseSourceRequest',
                'Required parameter "createCaseSourceRequest" was null or undefined when calling addSourceToCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/sources`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseSourceRequestToJSON(requestParameters['createCaseSourceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Adds a new source to an existing case.  **Source Technologies:** - `MSFT_XDR`: Microsoft XDR - `PALO_ALTO_XDR`: Palo Alto XDR - `PALO_ALTO_XSOAR`: Palo Alto XSOAR - `MSFT_SENTINEL`: Microsoft Sentinel - `CROWDSTRIKE`: CrowdStrike Falcon - `SENTINELONE`: SentinelOne - `SPLUNK`: Splunk - `QRADAR`: IBM QRadar - `NESSUS`: Tenable Nessus - `QUALYS`: Qualys - `RAPID7`: Rapid7 - `RSA_ARCHER`: RSA Archer - `SERVICENOW`: ServiceNow - `ETL_PIPELINE`: ETL Pipeline - `WEB_APP`: Web Application - `EMAIL`: Email - `UNKNOWN`: Unknown  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Source is automatically associated with the case\'s tenant 
     * Add source to case
     */
    async addSourceToCase(requestParameters: AddSourceToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.addSourceToCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submits structured feedback (thumbs up/down, ratings, etc.) for a case with field-level permission validation
     * Submit structured case feedback
     */
    async addStructuredFeedbackRaw(requestParameters: AddStructuredFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addStructuredFeedback().'
            );
        }

        if (requestParameters['addFeedbackInput'] == null) {
            throw new runtime.RequiredError(
                'addFeedbackInput',
                'Required parameter "addFeedbackInput" was null or undefined when calling addStructuredFeedback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{id}/structured-feedback`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddFeedbackInputToJSON(requestParameters['addFeedbackInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Submits structured feedback (thumbs up/down, ratings, etc.) for a case with field-level permission validation
     * Submit structured case feedback
     */
    async addStructuredFeedback(requestParameters: AddStructuredFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.addStructuredFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Assigns a case to a specific user for investigation or handling
     * Assign case to user
     */
    async assignCaseRaw(requestParameters: AssignCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling assignCase().'
            );
        }

        if (requestParameters['assignCaseRequest'] == null) {
            throw new runtime.RequiredError(
                'assignCaseRequest',
                'Required parameter "assignCaseRequest" was null or undefined when calling assignCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/assign`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssignCaseRequestToJSON(requestParameters['assignCaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Assigns a case to a specific user for investigation or handling
     * Assign case to user
     */
    async assignCase(requestParameters: AssignCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.assignCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Changes the owner of a case to a different user
     * Change case owner
     */
    async changeOwnerRaw(requestParameters: ChangeOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling changeOwner().'
            );
        }

        if (requestParameters['assignCaseRequest'] == null) {
            throw new runtime.RequiredError(
                'assignCaseRequest',
                'Required parameter "assignCaseRequest" was null or undefined when calling changeOwner().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/owner`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssignCaseRequestToJSON(requestParameters['assignCaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Changes the owner of a case to a different user
     * Change case owner
     */
    async changeOwner(requestParameters: ChangeOwnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.changeOwnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Changes the severity level of a case with optional reason
     * Change case severity
     */
    async changeSeverityRaw(requestParameters: ChangeSeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling changeSeverity().'
            );
        }

        if (requestParameters['severityChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'severityChangeRequest',
                'Required parameter "severityChangeRequest" was null or undefined when calling changeSeverity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/severity`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SeverityChangeRequestToJSON(requestParameters['severityChangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Changes the severity level of a case with optional reason
     * Change case severity
     */
    async changeSeverity(requestParameters: ChangeSeverityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.changeSeverityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Changes the status of a case to a new status with optional reason
     * Change case status
     */
    async changeStatusRaw(requestParameters: ChangeStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling changeStatus().'
            );
        }

        if (requestParameters['statusChangeRequest'] == null) {
            throw new runtime.RequiredError(
                'statusChangeRequest',
                'Required parameter "statusChangeRequest" was null or undefined when calling changeStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/status`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StatusChangeRequestToJSON(requestParameters['statusChangeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Changes the status of a case to a new status with optional reason
     * Change case status
     */
    async changeStatus(requestParameters: ChangeStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.changeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new security case with case type permission validation.  **Required Fields:** - `name`: Case name/title (required) - `severity`: Case severity level (required)  **Optional Fields:** - `summary`: Detailed case description - `case_type_id`: ID of the case type - `owner`: Case owner/assignee - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:create permission - Case type creation requires specific category permissions - Field-level permissions are validated for sensitive operations  **Security & Access Control:** - All cases are created in the current tenant context - Case type permissions are validated - All creation actions are audited for compliance 
     * Create new case
     */
    async createCaseRaw(requestParameters: CreateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['createCaseRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseRequest',
                'Required parameter "createCaseRequest" was null or undefined when calling createCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseRequestToJSON(requestParameters['createCaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new security case with case type permission validation.  **Required Fields:** - `name`: Case name/title (required) - `severity`: Case severity level (required)  **Optional Fields:** - `summary`: Detailed case description - `case_type_id`: ID of the case type - `owner`: Case owner/assignee - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:create permission - Case type creation requires specific category permissions - Field-level permissions are validated for sensitive operations  **Security & Access Control:** - All cases are created in the current tenant context - Case type permissions are validated - All creation actions are audited for compliance 
     * Create new case
     */
    async createCase(requestParameters: CreateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.createCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * De-escalates a case, removing the escalated flag and changing status back to IN_PROGRESS
     * De-escalate case
     */
    async deEscalateCaseRaw(requestParameters: DeEscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling deEscalateCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{caseId}/de-escalate`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * De-escalates a case, removing the escalated flag and changing status back to IN_PROGRESS
     * De-escalate case
     */
    async deEscalateCase(requestParameters: DeEscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.deEscalateCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **PERMANENTLY DELETES** a case and all related data. This is a **HARD DELETE** operation that:  • Completely removes the case from the database • Deletes ALL related events, entities, sources, feedback, and close reasons • Cannot be undone - the case and all associated data is permanently lost • Maintains audit trail of the deletion operation  **Warning**: This operation is irreversible. Consider exporting case data before deletion if needed for compliance or historical purposes.  **Related Data Deleted:** - All timeline events - All case entities (IOCs, indicators) - All case sources - All case feedback entries - Close reason (if exists)  **Security**: Requires `cases:remove` permission and MAC policy compliance. 
     * Permanently delete case
     */
    async deleteCaseRaw(requestParameters: DeleteCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * **PERMANENTLY DELETES** a case and all related data. This is a **HARD DELETE** operation that:  • Completely removes the case from the database • Deletes ALL related events, entities, sources, feedback, and close reasons • Cannot be undone - the case and all associated data is permanently lost • Maintains audit trail of the deletion operation  **Warning**: This operation is irreversible. Consider exporting case data before deletion if needed for compliance or historical purposes.  **Related Data Deleted:** - All timeline events - All case entities (IOCs, indicators) - All case sources - All case feedback entries - Close reason (if exists)  **Security**: Requires `cases:remove` permission and MAC policy compliance. 
     * Permanently delete case
     */
    async deleteCase(requestParameters: DeleteCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCaseRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a specific event from a case with field-level permission validation
     * Delete case event
     */
    async deleteCaseEventRaw(requestParameters: DeleteCaseEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling deleteCaseEvent().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteCaseEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{caseId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a specific event from a case with field-level permission validation
     * Delete case event
     */
    async deleteCaseEvent(requestParameters: DeleteCaseEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.deleteCaseEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes feedback for a case with field-level permission validation
     * Delete case feedback
     */
    async deleteCaseFeedbackRaw(requestParameters: DeleteCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling deleteCaseFeedback().'
            );
        }

        if (requestParameters['feedbackId'] == null) {
            throw new runtime.RequiredError(
                'feedbackId',
                'Required parameter "feedbackId" was null or undefined when calling deleteCaseFeedback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{caseId}/feedback/{feedbackId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace(`{${"feedbackId"}}`, encodeURIComponent(String(requestParameters['feedbackId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Deletes feedback for a case with field-level permission validation
     * Delete case feedback
     */
    async deleteCaseFeedback(requestParameters: DeleteCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.deleteCaseFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Escalates a case, marking it as escalated and changing status to ESCALATED
     * Escalate case
     */
    async escalateCaseRaw(requestParameters: EscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling escalateCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{caseId}/escalate`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Escalates a case, marking it as escalated and changing status to ESCALATED
     * Escalate case
     */
    async escalateCase(requestParameters: EscalateCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.escalateCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific case by ID with MAC policy enforcement
     * Get case by ID
     */
    async getCaseRaw(requestParameters: GetCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific case by ID with MAC policy enforcement
     * Get case by ID
     */
    async getCase(requestParameters: GetCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.getCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all available case categories for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case categories that can be used to: - Populate dropdown menus in case creation forms - Filter case types by category - Understand the different types of cases the system supports - Build category-based navigation and reporting  **Case Categories:** The system supports the following case categories:  - **SECURITY_INCIDENT** - Security incidents, breaches, and threats - **VULNERABILITY** - Vulnerability management and scanning results - **COMPLIANCE** - Policy violations and regulatory compliance issues - **RISK_ASSESSMENT** - Risk analysis and assessment activities - **SUPPORT** - General support requests and inquiries - **THREAT_INTELLIGENCE** - Threat intelligence and analysis - **AUDIT** - Audit findings and compliance reviews - **GENERAL** - Miscellaneous cases that don\'t fit other categories  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Categories are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-categories?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch categories for dropdown const response = await fetch(\'/api/v1/cases/case-categories?sessionId=\' + sessionId); const categories = await response.json();  // Populate category dropdown categories.data.forEach(category => {     dropdown.addOption(category.category, category.displayName); }); ```  **React Component Example:** ```jsx const [categories, setCategories] = useState([]);  useEffect(() => {     fetchCategories(); }, []);  const fetchCategories = async () => {     const response = await api.get(\'/cases/case-categories\', {         params: { sessionId }     });     setCategories(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Categories are static and rarely change - Consider caching results on the frontend - Response is lightweight and fast 
     * Get case categories
     */
    async getCaseCategoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseCategoryListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/case-categories`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseCategoryListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all available case categories for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case categories that can be used to: - Populate dropdown menus in case creation forms - Filter case types by category - Understand the different types of cases the system supports - Build category-based navigation and reporting  **Case Categories:** The system supports the following case categories:  - **SECURITY_INCIDENT** - Security incidents, breaches, and threats - **VULNERABILITY** - Vulnerability management and scanning results - **COMPLIANCE** - Policy violations and regulatory compliance issues - **RISK_ASSESSMENT** - Risk analysis and assessment activities - **SUPPORT** - General support requests and inquiries - **THREAT_INTELLIGENCE** - Threat intelligence and analysis - **AUDIT** - Audit findings and compliance reviews - **GENERAL** - Miscellaneous cases that don\'t fit other categories  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Categories are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-categories?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch categories for dropdown const response = await fetch(\'/api/v1/cases/case-categories?sessionId=\' + sessionId); const categories = await response.json();  // Populate category dropdown categories.data.forEach(category => {     dropdown.addOption(category.category, category.displayName); }); ```  **React Component Example:** ```jsx const [categories, setCategories] = useState([]);  useEffect(() => {     fetchCategories(); }, []);  const fetchCategories = async () => {     const response = await api.get(\'/cases/case-categories\', {         params: { sessionId }     });     setCategories(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Categories are static and rarely change - Consider caching results on the frontend - Response is lightweight and fast 
     * Get case categories
     */
    async getCaseCategories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseCategoryListResponse> {
        const response = await this.getCaseCategoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all feedback for a case
     * Get case feedback
     */
    async getCaseFeedbackRaw(requestParameters: GetCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCaseFeedback().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{id}/feedback`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all feedback for a case
     * Get case feedback
     */
    async getCaseFeedback(requestParameters: GetCaseFeedbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.getCaseFeedbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves aggregated case statistics with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    provides aggregated statistics from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the specified tenant IDs 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Provides statistics aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Statistics Included:** - Total case count - Cases by status (Open, In Progress, Resolved, etc.) - Cases by severity (Critical, High, Medium, Low) - Escalated cases count - Cases by tenant (for multi-tenant views) - Recent activity (last 30 days) - Tenant context information (selectedTenants, isMultiTenant)  **Security & Access Control:** - All statistics are filtered by Row Level Security (RLS) policies - User must have \'cases:read\' permission for the requested tenants - Access validation ensures user can only see statistics for authorized tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **Use Cases:** - Dashboard statistics based on user\'s tenant selection - Cross-tenant reporting and aggregation - Real-time statistics for selected tenant scope 
     * Get case statistics with flexible tenant selection
     */
    async getCaseStatisticsRaw(requestParameters: GetCaseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['createdFrom'] != null) {
            queryParameters['createdFrom'] = (requestParameters['createdFrom'] as any).toISOString();
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['createdTo'] = (requestParameters['createdTo'] as any).toISOString();
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['escalated'] != null) {
            queryParameters['escalated'] = requestParameters['escalated'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['sourceId'] = requestParameters['sourceId'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['tenantName'] != null) {
            queryParameters['tenantName'] = requestParameters['tenantName'];
        }

        if (requestParameters['updatedFrom'] != null) {
            queryParameters['updatedFrom'] = (requestParameters['updatedFrom'] as any).toISOString();
        }

        if (requestParameters['updatedTo'] != null) {
            queryParameters['updatedTo'] = (requestParameters['updatedTo'] as any).toISOString();
        }

        if (requestParameters['entities'] != null) {
            queryParameters['entities'] = requestParameters['entities'];
        }

        if (requestParameters['events'] != null) {
            queryParameters['events'] = requestParameters['events'];
        }

        if (requestParameters['matchCase'] != null) {
            queryParameters['matchCase'] = requestParameters['matchCase'];
        }

        if (requestParameters['wholeWord'] != null) {
            queryParameters['wholeWord'] = requestParameters['wholeWord'];
        }

        if (requestParameters['useRegex'] != null) {
            queryParameters['useRegex'] = requestParameters['useRegex'];
        }

        if (requestParameters['resolutionReasonValues'] != null) {
            queryParameters['resolutionReasonValues'] = requestParameters['resolutionReasonValues'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieves aggregated case statistics with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    provides aggregated statistics from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the specified tenant IDs 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Provides statistics aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Statistics Included:** - Total case count - Cases by status (Open, In Progress, Resolved, etc.) - Cases by severity (Critical, High, Medium, Low) - Escalated cases count - Cases by tenant (for multi-tenant views) - Recent activity (last 30 days) - Tenant context information (selectedTenants, isMultiTenant)  **Security & Access Control:** - All statistics are filtered by Row Level Security (RLS) policies - User must have \'cases:read\' permission for the requested tenants - Access validation ensures user can only see statistics for authorized tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases/statistics?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **Use Cases:** - Dashboard statistics based on user\'s tenant selection - Cross-tenant reporting and aggregation - Real-time statistics for selected tenant scope 
     * Get case statistics with flexible tenant selection
     */
    async getCaseStatistics(requestParameters: GetCaseStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCaseStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all available case types for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case types that can be used to: - Populate case type selection in case creation forms - Understand the different types of cases the system supports - Build type-based filtering and reporting - Determine workflow configurations for different case types  **Case Types:** The system includes predefined case types across various categories:  **Security Incidents:** - MALWARE_DETECTION - Detection of malicious software or code - PHISHING_ATTEMPT - Suspicious email or website attempting to steal credentials - UNAUTHORIZED_ACCESS - Suspicious login or access attempt - DATA_EXFILTRATION - Suspicious data transfer or download activity - SOCIAL_ENGINEERING - Manipulation attempt to gain unauthorized access - INSIDER_THREAT - Suspicious activity from internal user - DDoS_ATTACK - Distributed denial of service attack - RANSOMWARE_ATTEMPT - Ransomware detection or attempt  **Other Categories:** - VULNERABILITY_SCAN - Automated vulnerability detection - COMPLIANCE_VIOLATION - Policy or regulatory compliance issue  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Case types are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-types?sessionId=abc123&page=1&pageSize=10 ```  **Frontend Integration:** ```javascript // Fetch case types for dropdown const response = await fetch(\'/api/v1/cases/case-types?sessionId=\' + sessionId); const caseTypes = await response.json();  // Populate case type dropdown caseTypes.data.forEach(caseType => {     dropdown.addOption(caseType.id, caseType.displayName); }); ```  **React Component Example:** ```jsx const [caseTypes, setCaseTypes] = useState([]);  useEffect(() => {     fetchCaseTypes(); }, []);  const fetchCaseTypes = async () => {     const response = await api.get(\'/cases/case-types\', {         params: { sessionId, page: 1, pageSize: 50 }     });     setCaseTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Supports pagination for large datasets 
     * Get case types
     */
    async getCaseTypesRaw(requestParameters: GetCaseTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/case-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseTypeListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all available case types for the security case management system.  **Purpose:** This endpoint provides a comprehensive list of case types that can be used to: - Populate case type selection in case creation forms - Understand the different types of cases the system supports - Build type-based filtering and reporting - Determine workflow configurations for different case types  **Case Types:** The system includes predefined case types across various categories:  **Security Incidents:** - MALWARE_DETECTION - Detection of malicious software or code - PHISHING_ATTEMPT - Suspicious email or website attempting to steal credentials - UNAUTHORIZED_ACCESS - Suspicious login or access attempt - DATA_EXFILTRATION - Suspicious data transfer or download activity - SOCIAL_ENGINEERING - Manipulation attempt to gain unauthorized access - INSIDER_THREAT - Suspicious activity from internal user - DDoS_ATTACK - Distributed denial of service attack - RANSOMWARE_ATTEMPT - Ransomware detection or attempt  **Other Categories:** - VULNERABILITY_SCAN - Automated vulnerability detection - COMPLIANCE_VIOLATION - Policy or regulatory compliance issue  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Case types are system-wide and not tenant-specific  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/case-types?sessionId=abc123&page=1&pageSize=10 ```  **Frontend Integration:** ```javascript // Fetch case types for dropdown const response = await fetch(\'/api/v1/cases/case-types?sessionId=\' + sessionId); const caseTypes = await response.json();  // Populate case type dropdown caseTypes.data.forEach(caseType => {     dropdown.addOption(caseType.id, caseType.displayName); }); ```  **React Component Example:** ```jsx const [caseTypes, setCaseTypes] = useState([]);  useEffect(() => {     fetchCaseTypes(); }, []);  const fetchCaseTypes = async () => {     const response = await api.get(\'/cases/case-types\', {         params: { sessionId, page: 1, pageSize: 50 }     });     setCaseTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Supports pagination for large datasets 
     * Get case types
     */
    async getCaseTypes(requestParameters: GetCaseTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse> {
        const response = await this.getCaseTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves case types filtered by category
     * Get case types by category
     */
    async getCaseTypesByCategoryRaw(requestParameters: GetCaseTypesByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling getCaseTypesByCategory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageParam'] != null) {
            queryParameters['pageParam'] = requestParameters['pageParam'];
        }

        if (requestParameters['pageSizeParam'] != null) {
            queryParameters['pageSizeParam'] = requestParameters['pageSizeParam'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/case-types/category/{category}`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseTypeListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves case types filtered by category
     * Get case types by category
     */
    async getCaseTypesByCategory(requestParameters: GetCaseTypesByCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse> {
        const response = await this.getCaseTypesByCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves case types filtered by category
     * Get case types by category
     */
    async getCaseTypesByCategory1Raw(requestParameters: GetCaseTypesByCategory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>> {
        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling getCaseTypesByCategory1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageParam'] != null) {
            queryParameters['pageParam'] = requestParameters['pageParam'];
        }

        if (requestParameters['pageSizeParam'] != null) {
            queryParameters['pageSizeParam'] = requestParameters['pageSizeParam'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/case-types/{category}`;
        urlPath = urlPath.replace(`{${"category"}}`, encodeURIComponent(String(requestParameters['category'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseTypeListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves case types filtered by category
     * Get case types by category
     */
    async getCaseTypesByCategory1(requestParameters: GetCaseTypesByCategory1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse> {
        const response = await this.getCaseTypesByCategory1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of security cases with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns cases from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns cases aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Security & Access Control:** - All cases are filtered by Row Level Security (RLS) policies - MAC (Mandatory Access Control) policies are enforced for individual case access - User must have \'cases:read\' permission for the requested tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **With Pagination:** - `GET /api/v1/cases?sessionId=abc123&page=2&pageSize=20`   → Uses session selection with pagination 
     * Get cases with flexible tenant selection
     */
    async getCasesRaw(requestParameters: GetCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['includeCollections'] != null) {
            queryParameters['includeCollections'] = requestParameters['includeCollections'];
        }

        if (requestParameters['include'] != null) {
            queryParameters['include'] = requestParameters['include'];
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['escalated'] != null) {
            queryParameters['escalated'] = requestParameters['escalated'];
        }

        if (requestParameters['excludedCaseIds'] != null) {
            queryParameters['excludedCaseIds'] = requestParameters['excludedCaseIds'];
        }

        if (requestParameters['resolutionReasonValues'] != null) {
            queryParameters['resolutionReasonValues'] = requestParameters['resolutionReasonValues'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sourceId'] != null) {
            queryParameters['sourceId'] = requestParameters['sourceId'];
        }

        if (requestParameters['sourceTechnology'] != null) {
            queryParameters['sourceTechnology'] = requestParameters['sourceTechnology'];
        }

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['tenantName'] != null) {
            queryParameters['tenantName'] = requestParameters['tenantName'];
        }

        if (requestParameters['createdFrom'] != null) {
            queryParameters['createdFrom'] = (requestParameters['createdFrom'] as any).toISOString();
        }

        if (requestParameters['createdTo'] != null) {
            queryParameters['createdTo'] = (requestParameters['createdTo'] as any).toISOString();
        }

        if (requestParameters['updatedFrom'] != null) {
            queryParameters['updatedFrom'] = (requestParameters['updatedFrom'] as any).toISOString();
        }

        if (requestParameters['updatedTo'] != null) {
            queryParameters['updatedTo'] = (requestParameters['updatedTo'] as any).toISOString();
        }

        if (requestParameters['entities'] != null) {
            queryParameters['entities'] = requestParameters['entities'];
        }

        if (requestParameters['events'] != null) {
            queryParameters['events'] = requestParameters['events'];
        }

        if (requestParameters['matchCase'] != null) {
            queryParameters['matchCase'] = requestParameters['matchCase'];
        }

        if (requestParameters['wholeWord'] != null) {
            queryParameters['wholeWord'] = requestParameters['wholeWord'];
        }

        if (requestParameters['useRegex'] != null) {
            queryParameters['useRegex'] = requestParameters['useRegex'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of security cases with flexible tenant selection behavior.  **DEFAULT BEHAVIOR (when tenantIds parameter is NOT provided):**  The endpoint uses the tenant selection configured in the user\'s session:  1. **Session Tenant Selection**: Uses `tenantIsolationService.getEffectiveTenantIds(sessionId)`    which returns the `selectedTenants` from the user\'s session 2. **Fallback to Current Tenant**: If no tenants are selected in the session,    it defaults to the current tenant only 3. **Multi-tenant Support**: If multiple tenants are selected in the session,    returns cases from all selected tenants  **OVERRIDE BEHAVIOR (when tenantIds parameter IS provided):**  The session tenant selection is explicitly overridden:  1. **Ignores Session Selection**: Completely ignores the `selectedTenants` in the session 2. **Uses Specified Tenants**: Uses only the tenant IDs provided in the `tenantIds` parameter 3. **Access Validation**: Validates that the user has access to all requested tenants 4. **Aggregation**: Returns cases aggregated from the specified tenants  **Tenant Selection Priority:** 1. If `tenantIds` parameter is provided → Use specified tenants (OVERRIDE) 2. If `tenantIds` parameter is NOT provided → Use session selected tenants (DEFAULT) 3. If no tenants selected in session → Use current tenant only (FALLBACK)  **Security & Access Control:** - All cases are filtered by Row Level Security (RLS) policies - MAC (Mandatory Access Control) policies are enforced for individual case access - User must have \'cases:read\' permission for the requested tenants  **Examples:**  **Default Mode (Session Selection):** - `GET /api/v1/cases?sessionId=abc123`   → Uses selectedTenants from session, or current tenant if none selected  **Override Mode (Explicit Tenant Selection):** - `GET /api/v1/cases?sessionId=abc123&tenantIds=tenant1,tenant2`   → Ignores session selection, uses only tenant1 and tenant2  **With Pagination:** - `GET /api/v1/cases?sessionId=abc123&page=2&pageSize=20`   → Uses session selection with pagination 
     * Get cases with flexible tenant selection
     */
    async getCases(requestParameters: GetCasesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseListResponse> {
        const response = await this.getCasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves case types that the current user has permission to create.  **Purpose:** This endpoint provides a filtered list of case types based on the user\'s permissions. It\'s used to populate case creation forms with only the case types the user can create.  **Field-Level Permission Integration:** The response is filtered based on the user\'s case type creation permissions: - **cases:create:security_incident** - Can create security incident cases - **cases:create:vulnerability** - Can create vulnerability cases - **cases:create:compliance** - Can create compliance cases - **cases:create:risk_assessment** - Can create risk assessment cases - **cases:create:support** - Can create support cases - **cases:create:threat_intelligence** - Can create threat intelligence cases - **cases:create:audit** - Can create audit cases - **cases:create:general** - Can create general cases - **cases:create:all** - Can create all case types  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Response is filtered based on user\'s field-level permissions  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/creatable-types?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch creatable case types for dropdown const response = await fetch(\'/api/v1/cases/creatable-types?sessionId=\' + sessionId); const creatableTypes = await response.json();  // Populate case type dropdown with only allowed types creatableTypes.data.forEach(caseType => {     dropdown.addOption(caseType.typeCode, caseType.displayName); }); ```  **React Component Example:** ```jsx const [creatableTypes, setCreatableTypes] = useState([]);  useEffect(() => {     fetchCreatableTypes(); }, []);  const fetchCreatableTypes = async () => {     const response = await api.get(\'/cases/creatable-types\', {         params: { sessionId }     });     setCreatableTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Response is filtered based on permissions, so it\'s always relevant 
     * Get creatable case types
     */
    async getCreatableCaseTypes1Raw(requestParameters: GetCreatableCaseTypes1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/creatable-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseTypeListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves case types that the current user has permission to create.  **Purpose:** This endpoint provides a filtered list of case types based on the user\'s permissions. It\'s used to populate case creation forms with only the case types the user can create.  **Field-Level Permission Integration:** The response is filtered based on the user\'s case type creation permissions: - **cases:create:security_incident** - Can create security incident cases - **cases:create:vulnerability** - Can create vulnerability cases - **cases:create:compliance** - Can create compliance cases - **cases:create:risk_assessment** - Can create risk assessment cases - **cases:create:support** - Can create support cases - **cases:create:threat_intelligence** - Can create threat intelligence cases - **cases:create:audit** - Can create audit cases - **cases:create:general** - Can create general cases - **cases:create:all** - Can create all case types  **Security & Access Control:** - Requires \'cases:read\' permission - Supports tenant isolation through session context - All API calls are audited for compliance and security monitoring - Response is filtered based on user\'s field-level permissions  **Usage Examples:**  **Basic Request:** ``` GET /api/v1/cases/creatable-types?sessionId=abc123 ```  **Frontend Integration:** ```javascript // Fetch creatable case types for dropdown const response = await fetch(\'/api/v1/cases/creatable-types?sessionId=\' + sessionId); const creatableTypes = await response.json();  // Populate case type dropdown with only allowed types creatableTypes.data.forEach(caseType => {     dropdown.addOption(caseType.typeCode, caseType.displayName); }); ```  **React Component Example:** ```jsx const [creatableTypes, setCreatableTypes] = useState([]);  useEffect(() => {     fetchCreatableTypes(); }, []);  const fetchCreatableTypes = async () => {     const response = await api.get(\'/cases/creatable-types\', {         params: { sessionId }     });     setCreatableTypes(response.data.data); }; ```  **Error Handling:** - 401: Invalid or missing session ID - 403: User lacks \'cases:read\' permission - 500: Internal server error  **Performance Considerations:** - Case types are relatively static and rarely change - Consider caching results on the frontend - Response is filtered based on permissions, so it\'s always relevant 
     * Get creatable case types
     */
    async getCreatableCaseTypes1(requestParameters: GetCreatableCaseTypes1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeListResponse> {
        const response = await this.getCreatableCaseTypes1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns resolved-case SLA aggregates grouped by user-local calendar day and severity. Fields `mtta`, `mttn`, `mttc`, and `mttd` under each severity node are **mean whole minutes** (rounded from per-case SLA timers stored in **seconds** on `security_case`), aligned with POST `/v1/cases/mttx-metrics-graph` widget duration semantics (Minutes). 
     * MTTX graph metrics by day and severity
     */
    async getMttxGraphMetricsRaw(requestParameters: GetMttxGraphMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MttxMetricsGraphResponse>> {
        if (requestParameters['lookback'] == null) {
            throw new runtime.RequiredError(
                'lookback',
                'Required parameter "lookback" was null or undefined when calling getMttxGraphMetrics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lookback'] != null) {
            queryParameters['lookback'] = requestParameters['lookback'];
        }

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/mttx-metrics-graph`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MttxMetricsGraphResponseFromJSON(jsonValue));
    }

    /**
     * Returns resolved-case SLA aggregates grouped by user-local calendar day and severity. Fields `mtta`, `mttn`, `mttc`, and `mttd` under each severity node are **mean whole minutes** (rounded from per-case SLA timers stored in **seconds** on `security_case`), aligned with POST `/v1/cases/mttx-metrics-graph` widget duration semantics (Minutes). 
     * MTTX graph metrics by day and severity
     */
    async getMttxGraphMetrics(requestParameters: GetMttxGraphMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MttxMetricsGraphResponse> {
        const response = await this.getMttxGraphMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves cases related to a specific case
     * Get related cases
     */
    async getRelatedCasesRaw(requestParameters: GetRelatedCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseListResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getRelatedCases().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{id}/related`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves cases related to a specific case
     * Get related cases
     */
    async getRelatedCases(requestParameters: GetRelatedCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseListResponse> {
        const response = await this.getRelatedCasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggregated metrics for Security Dashboard widgets (time series, donut, KPI). Uses the same tenant and session context as GET /mttx-metrics-graph. Table widgets must use GET /cases with the same UTC bounds as queryTimeRangeUtc in the response.  **Time series (chartType line, bar, or area):** Successful responses use kind `series`, include `points` (each `SeriesGraphPoint` uses uppercase severity keys CRITICAL, HIGH, MEDIUM, LOW, INFO on the wire), and include camelCase `xAxisLabel` and `yAxisLabel`. `yAxisLabel` is `Minutes` for mtta, mttn, mttc, and mttd (values are mean minutes per day and severity bucket) and `Totals` for caseCount. `xAxisLabel` summarizes the same local calendar day range used to build points, aligned with `queryTimeRangeUtc` (inclusive UTC `created` bounds). Line, bar, and area share the same axis semantics.  **Donut and KPI:** Axis label fields are not populated (null). Clients may fall back to local defaults. KPI responses include `value`, `displayMode` (`scalar` or `duration`), and `trendPercent` (percent change vs an immediately preceding period of equal UTC length with the same widget filters).  **Donut close reason metrics** (`donut_incidents_by_close_reason`, `donut_escalated_cases_by_disposition`): each segment `name` is the resolved case\'s `close_reason.description` text (aggregated per distinct description). Blank descriptions are grouped as `Unspecified`.  **Donut incidents by severity** (`donut_incidents_by_severity`): optional `widgetOptions.caseListFilters.escalation` of `escalated` or `nonEscalated` restricts counts to cases with that boolean `escalated` value in the `created` window; omitted or `all` includes all cases (same window and exclusions as other donuts).  **Preset date range:** when `dateRange.mode` is preset, `dateRange.days` uses the same UTC window and inclusive-end `created` bounds as GET `/v1/cases/mttx-metrics-graph` with `lookback` set to the same number. Custom `from`/`to` ranges remain full local civil days in the user\'s zone with an inclusive UTC end. 
     * Security Dashboard widget metrics
     */
    async postSecurityWidgetMetricsRaw(requestParameters: PostSecurityWidgetMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityWidgetMetricsResponse>> {
        if (requestParameters['securityWidgetQueryRequest'] == null) {
            throw new runtime.RequiredError(
                'securityWidgetQueryRequest',
                'Required parameter "securityWidgetQueryRequest" was null or undefined when calling postSecurityWidgetMetrics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/mttx-metrics-graph`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SecurityWidgetQueryRequestToJSON(requestParameters['securityWidgetQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityWidgetMetricsResponseFromJSON(jsonValue));
    }

    /**
     * Aggregated metrics for Security Dashboard widgets (time series, donut, KPI). Uses the same tenant and session context as GET /mttx-metrics-graph. Table widgets must use GET /cases with the same UTC bounds as queryTimeRangeUtc in the response.  **Time series (chartType line, bar, or area):** Successful responses use kind `series`, include `points` (each `SeriesGraphPoint` uses uppercase severity keys CRITICAL, HIGH, MEDIUM, LOW, INFO on the wire), and include camelCase `xAxisLabel` and `yAxisLabel`. `yAxisLabel` is `Minutes` for mtta, mttn, mttc, and mttd (values are mean minutes per day and severity bucket) and `Totals` for caseCount. `xAxisLabel` summarizes the same local calendar day range used to build points, aligned with `queryTimeRangeUtc` (inclusive UTC `created` bounds). Line, bar, and area share the same axis semantics.  **Donut and KPI:** Axis label fields are not populated (null). Clients may fall back to local defaults. KPI responses include `value`, `displayMode` (`scalar` or `duration`), and `trendPercent` (percent change vs an immediately preceding period of equal UTC length with the same widget filters).  **Donut close reason metrics** (`donut_incidents_by_close_reason`, `donut_escalated_cases_by_disposition`): each segment `name` is the resolved case\'s `close_reason.description` text (aggregated per distinct description). Blank descriptions are grouped as `Unspecified`.  **Donut incidents by severity** (`donut_incidents_by_severity`): optional `widgetOptions.caseListFilters.escalation` of `escalated` or `nonEscalated` restricts counts to cases with that boolean `escalated` value in the `created` window; omitted or `all` includes all cases (same window and exclusions as other donuts).  **Preset date range:** when `dateRange.mode` is preset, `dateRange.days` uses the same UTC window and inclusive-end `created` bounds as GET `/v1/cases/mttx-metrics-graph` with `lookback` set to the same number. Custom `from`/`to` ranges remain full local civil days in the user\'s zone with an inclusive UTC end. 
     * Security Dashboard widget metrics
     */
    async postSecurityWidgetMetrics(requestParameters: PostSecurityWidgetMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityWidgetMetricsResponse> {
        const response = await this.postSecurityWidgetMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * POST equivalent of GET /v1/cases/statistics with the same filter semantics.
     * Filtered case statistics query
     */
    async queryCaseStatisticsRaw(requestParameters: QueryCaseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['caseStatisticsQueryRequest'] == null) {
            throw new runtime.RequiredError(
                'caseStatisticsQueryRequest',
                'Required parameter "caseStatisticsQueryRequest" was null or undefined when calling queryCaseStatistics().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/statistics/query`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CaseStatisticsQueryRequestToJSON(requestParameters['caseStatisticsQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * POST equivalent of GET /v1/cases/statistics with the same filter semantics.
     * Filtered case statistics query
     */
    async queryCaseStatistics(requestParameters: QueryCaseStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.queryCaseStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a specific custom field from a case. This endpoint allows granular removal of individual custom fields without affecting other custom fields.  **Features:** - Removes a single custom field by key - Preserves all other existing custom fields - Maintains audit trail of removal - Returns error if field doesn\'t exist  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Removal is automatically associated with the case\'s tenant 
     * Remove a custom field from a case
     */
    async removeCaseCustomFieldRaw(requestParameters: RemoveCaseCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling removeCaseCustomField().'
            );
        }

        if (requestParameters['fieldKey'] == null) {
            throw new runtime.RequiredError(
                'fieldKey',
                'Required parameter "fieldKey" was null or undefined when calling removeCaseCustomField().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{caseId}/custom-fields/{fieldKey}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace(`{${"fieldKey"}}`, encodeURIComponent(String(requestParameters['fieldKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Removes a specific custom field from a case. This endpoint allows granular removal of individual custom fields without affecting other custom fields.  **Features:** - Removes a single custom field by key - Preserves all other existing custom fields - Maintains audit trail of removal - Returns error if field doesn\'t exist  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Removal is automatically associated with the case\'s tenant 
     * Remove a custom field from a case
     */
    async removeCaseCustomField(requestParameters: RemoveCaseCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.removeCaseCustomFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reopens a previously resolved case with field-level permission validation
     * Reopen case
     */
    async reopenCaseRaw(requestParameters: ReopenCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling reopenCase().'
            );
        }

        if (requestParameters['reason'] == null) {
            throw new runtime.RequiredError(
                'reason',
                'Required parameter "reason" was null or undefined when calling reopenCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{id}/reopen`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Reopens a previously resolved case with field-level permission validation
     * Reopen case
     */
    async reopenCase(requestParameters: ReopenCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.reopenCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolves a case with specified reason and close rationale with field-level permission validation.  **Purpose:** This endpoint marks a case as resolved, indicating that the security incident has been fully investigated and remediated with appropriate actions taken.  **Status Change:** - Sets case status to RESOLVED - Records close reason and rationale - Creates timeline event for resolution - Maintains audit trail of resolution  **Field-Level Permissions:** - Requires cases:update:status or cases:update:all - Status changes require appropriate field-level permissions  **Request Body:** - closeReason: Structured close reason with category and subcategory - closeRationale: Detailed explanation of why the case was resolved - feedback: Optional feedback about the case handling process  **Security & Access Control:** - Requires \'cases:update\' permission - Field-level permissions are validated for status changes - Supports tenant isolation through session context - All resolution actions are audited for compliance  **Usage Examples:**  **Basic Resolution:** ```json {   \"closeReason\": {     \"category\": \"confirmed_threat\",     \"subCategory\": \"rule_logic_error\",     \"description\": \"Threat confirmed and contained\"   },   \"closeRationale\": \"Malware was successfully removed from affected systems\",   \"feedback\": \"Good response time and containment\" } ```  **False Positive Resolution:** ```json {   \"closeReason\": {     \"category\": \"legitimate_activity\",     \"subCategory\": \"known_system_behavior\",     \"description\": \"False positive - legitimate user activity\"   },   \"closeRationale\": \"User was performing authorized testing\",   \"feedback\": null } ``` 
     * Resolve case
     */
    async resolveCaseRaw(requestParameters: ResolveCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resolveCase().'
            );
        }

        if (requestParameters['closeCaseRequest'] == null) {
            throw new runtime.RequiredError(
                'closeCaseRequest',
                'Required parameter "closeCaseRequest" was null or undefined when calling resolveCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{id}/resolve`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CloseCaseRequestToJSON(requestParameters['closeCaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Resolves a case with specified reason and close rationale with field-level permission validation.  **Purpose:** This endpoint marks a case as resolved, indicating that the security incident has been fully investigated and remediated with appropriate actions taken.  **Status Change:** - Sets case status to RESOLVED - Records close reason and rationale - Creates timeline event for resolution - Maintains audit trail of resolution  **Field-Level Permissions:** - Requires cases:update:status or cases:update:all - Status changes require appropriate field-level permissions  **Request Body:** - closeReason: Structured close reason with category and subcategory - closeRationale: Detailed explanation of why the case was resolved - feedback: Optional feedback about the case handling process  **Security & Access Control:** - Requires \'cases:update\' permission - Field-level permissions are validated for status changes - Supports tenant isolation through session context - All resolution actions are audited for compliance  **Usage Examples:**  **Basic Resolution:** ```json {   \"closeReason\": {     \"category\": \"confirmed_threat\",     \"subCategory\": \"rule_logic_error\",     \"description\": \"Threat confirmed and contained\"   },   \"closeRationale\": \"Malware was successfully removed from affected systems\",   \"feedback\": \"Good response time and containment\" } ```  **False Positive Resolution:** ```json {   \"closeReason\": {     \"category\": \"legitimate_activity\",     \"subCategory\": \"known_system_behavior\",     \"description\": \"False positive - legitimate user activity\"   },   \"closeRationale\": \"User was performing authorized testing\",   \"feedback\": null } ``` 
     * Resolve case
     */
    async resolveCase(requestParameters: ResolveCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.resolveCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets or updates a single custom field value for a case. This endpoint allows granular control over individual custom fields without affecting other custom fields.  **Features:** - Sets or updates a single custom field - Preserves all other existing custom fields - Supports any JSON data type - Maintains audit trail  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Field is automatically associated with the case\'s tenant 
     * Set a single custom field value
     */
    async setCustomFieldRaw(requestParameters: SetCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling setCustomField().'
            );
        }

        if (requestParameters['fieldKey'] == null) {
            throw new runtime.RequiredError(
                'fieldKey',
                'Required parameter "fieldKey" was null or undefined when calling setCustomField().'
            );
        }

        if (requestParameters['customFieldValueRequest'] == null) {
            throw new runtime.RequiredError(
                'customFieldValueRequest',
                'Required parameter "customFieldValueRequest" was null or undefined when calling setCustomField().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/custom-fields/{fieldKey}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace(`{${"fieldKey"}}`, encodeURIComponent(String(requestParameters['fieldKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CustomFieldValueRequestToJSON(requestParameters['customFieldValueRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Sets or updates a single custom field value for a case. This endpoint allows granular control over individual custom fields without affecting other custom fields.  **Features:** - Sets or updates a single custom field - Preserves all other existing custom fields - Supports any JSON data type - Maintains audit trail  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Field is automatically associated with the case\'s tenant 
     * Set a single custom field value
     */
    async setCustomField(requestParameters: SetCustomFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.setCustomFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes the current assignment from a case, making it unassigned
     * Unassign case
     */
    async unassignCaseRaw(requestParameters: UnassignCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling unassignCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cases/{caseId}/unassign`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Removes the current assignment from a case, making it unassigned
     * Unassign case
     */
    async unassignCase(requestParameters: UnassignCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.unassignCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing case with field-level permission validation.  **Updatable Fields:** - `name`: Case name/title - `summary`: Detailed case description - `severity`: Case severity level - `status`: Case status - `owner`: Case owner/assignee - `escalated`: Whether the case has been escalated - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:update permission - Different field-level permissions for different update types - Status changes require cases:update:status or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions 
     * Update case
     */
    async updateCaseRaw(requestParameters: UpdateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCase().'
            );
        }

        if (requestParameters['updateCaseRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCaseRequest',
                'Required parameter "updateCaseRequest" was null or undefined when calling updateCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCaseRequestToJSON(requestParameters['updateCaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing case with field-level permission validation.  **Updatable Fields:** - `name`: Case name/title - `summary`: Detailed case description - `severity`: Case severity level - `status`: Case status - `owner`: Case owner/assignee - `escalated`: Whether the case has been escalated - `entities`: List of entities associated with the case - `custom_fields`: Custom fields for the case - `sources`: List of sources for this case - `correlation_group`: Group for linking related cases - `correlation_metadata`: Metadata for case correlation - `source_id`: Source ID from external system - `source_technology`: Source technology that generated this case  **Field-Level Permissions:** - Requires cases:update permission - Different field-level permissions for different update types - Status changes require cases:update:status or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions 
     * Update case
     */
    async updateCase(requestParameters: UpdateCaseOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.updateCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing case type with field-level permission validation.  **Updatable Fields:** - `displayName`: Display name of the case type - `description`: Description of the case type - `defaultSeverity`: Default severity level for cases of this type - `workflowConfig`: Workflow configuration (auto-assignment, escalation rules, SLA hours) - `requiredFields`: Required fields configuration for case creation - `isActive`: Whether the case type is active and available for use  **Field-Level Permissions:** - Requires cases:update:configuration permission - Workflow configuration changes require cases:update:workflow or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions - Case types are system-wide and affect all tenants  **Workflow Configuration Examples:** ```json {   \"autoAssign\": true,   \"escalationRules\": [\"24h\", \"48h\", \"72h\"],   \"slaHours\": 24,   \"notificationChannels\": [\"email\", \"slack\"],   \"approvalRequired\": false } ```  **Required Fields Configuration Examples:** ```json {   \"name\": \"required\",   \"summary\": \"required\",   \"severity\": \"optional\",   \"owner\": \"optional\",   \"custom_fields\": {     \"affected_systems\": \"required\",     \"threat_family\": \"optional\"   } } ``` 
     * Update case type
     */
    async updateCaseTypeRaw(requestParameters: UpdateCaseTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseTypeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCaseType().'
            );
        }

        if (requestParameters['updateCaseTypeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCaseTypeRequest',
                'Required parameter "updateCaseTypeRequest" was null or undefined when calling updateCaseType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/case-types/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCaseTypeRequestToJSON(requestParameters['updateCaseTypeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseTypeResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing case type with field-level permission validation.  **Updatable Fields:** - `displayName`: Display name of the case type - `description`: Description of the case type - `defaultSeverity`: Default severity level for cases of this type - `workflowConfig`: Workflow configuration (auto-assignment, escalation rules, SLA hours) - `requiredFields`: Required fields configuration for case creation - `isActive`: Whether the case type is active and available for use  **Field-Level Permissions:** - Requires cases:update:configuration permission - Workflow configuration changes require cases:update:workflow or cases:update:all - Basic updates require cases:update:basic or cases:update:all  **Security & Access Control:** - All updates are validated against field-level permissions - Changes are audited for compliance - Only authorized fields can be updated based on user permissions - Case types are system-wide and affect all tenants  **Workflow Configuration Examples:** ```json {   \"autoAssign\": true,   \"escalationRules\": [\"24h\", \"48h\", \"72h\"],   \"slaHours\": 24,   \"notificationChannels\": [\"email\", \"slack\"],   \"approvalRequired\": false } ```  **Required Fields Configuration Examples:** ```json {   \"name\": \"required\",   \"summary\": \"required\",   \"severity\": \"optional\",   \"owner\": \"optional\",   \"custom_fields\": {     \"affected_systems\": \"required\",     \"threat_family\": \"optional\"   } } ``` 
     * Update case type
     */
    async updateCaseType(requestParameters: UpdateCaseTypeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseTypeResponse> {
        const response = await this.updateCaseTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates custom fields for an existing case. Custom fields provide flexible storage for case-specific metadata that doesn\'t fit into standard case fields.  **Custom Fields Features:** - Support for any JSON data type (strings, numbers, booleans, arrays, objects) - Flexible key-value storage - Overwrites existing custom fields with the provided data - Maintains audit trail of all changes  **Use Cases:** - Department-specific metadata - Integration with external systems - Custom workflow data - Additional categorization - Compliance tracking fields  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Custom fields are automatically associated with the case\'s tenant 
     * Update custom fields for a case
     */
    async updateCustomFieldsRaw(requestParameters: UpdateCustomFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateCustomFields().'
            );
        }

        if (requestParameters['customFieldRequest'] == null) {
            throw new runtime.RequiredError(
                'customFieldRequest',
                'Required parameter "customFieldRequest" was null or undefined when calling updateCustomFields().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/custom-fields`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomFieldRequestToJSON(requestParameters['customFieldRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Updates custom fields for an existing case. Custom fields provide flexible storage for case-specific metadata that doesn\'t fit into standard case fields.  **Custom Fields Features:** - Support for any JSON data type (strings, numbers, booleans, arrays, objects) - Flexible key-value storage - Overwrites existing custom fields with the provided data - Maintains audit trail of all changes  **Use Cases:** - Department-specific metadata - Integration with external systems - Custom workflow data - Additional categorization - Compliance tracking fields  **Security & Access Control:** - Requires cases:update permission - All changes are audited for compliance - Custom fields are automatically associated with the case\'s tenant 
     * Update custom fields for a case
     */
    async updateCustomFields(requestParameters: UpdateCustomFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.updateCustomFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a specific event within a case with field-level permission validation. This unified endpoint handles all event types:  **Supported Event Types:** - **Notes** (`note`): Updates the note content directly (requires cases:update:notes) - **Feedback** (`feedback`, `case_feedback`): Updates the underlying feedback entity and regenerates event content (requires events:create:feedback) - **Other Events**: Updates event content directly (requires cases:update:all)  **For Feedback Events:** - Extracts the feedback ID from event metadata - Updates the underlying CaseFeedback entity using structured data - Supports full feedback updates (rating, comment, feedbackType, metadata) - Regenerates the event content to reflect changes - Maintains the same response format (updated case with events)  **For Other Events:** - Updates the event content directly - Preserves existing event structure  **Field-Level Permissions:** - Note events: cases:update:notes or cases:update:all - Feedback events: events:create:feedback or cases:update:all - Other events: cases:update:all  **Request Body Format:** - For notes: `{\"content\": \"Updated note text\"}` - For feedback: `{\"comment\": \"Updated comment\", \"rating\": \"THUMBS_UP\", \"feedbackType\": \"CASE_FEEDBACK\"}` - For other events: `{\"content\": \"Updated content\"}`  **Response Format:** Always returns the updated case with the complete events array, ensuring consistency regardless of event type being updated.  **Benefits:** - Unified API for all timeline updates - No need for frontend to know about feedback IDs - Consistent response format - Clean, unambiguous design - Field-level permission validation 
     * Update case event
     */
    async updateEventRaw(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling updateEvent().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling updateEvent().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cases/{caseId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseResponseFromJSON(jsonValue));
    }

    /**
     * Updates a specific event within a case with field-level permission validation. This unified endpoint handles all event types:  **Supported Event Types:** - **Notes** (`note`): Updates the note content directly (requires cases:update:notes) - **Feedback** (`feedback`, `case_feedback`): Updates the underlying feedback entity and regenerates event content (requires events:create:feedback) - **Other Events**: Updates event content directly (requires cases:update:all)  **For Feedback Events:** - Extracts the feedback ID from event metadata - Updates the underlying CaseFeedback entity using structured data - Supports full feedback updates (rating, comment, feedbackType, metadata) - Regenerates the event content to reflect changes - Maintains the same response format (updated case with events)  **For Other Events:** - Updates the event content directly - Preserves existing event structure  **Field-Level Permissions:** - Note events: cases:update:notes or cases:update:all - Feedback events: events:create:feedback or cases:update:all - Other events: cases:update:all  **Request Body Format:** - For notes: `{\"content\": \"Updated note text\"}` - For feedback: `{\"comment\": \"Updated comment\", \"rating\": \"THUMBS_UP\", \"feedbackType\": \"CASE_FEEDBACK\"}` - For other events: `{\"content\": \"Updated content\"}`  **Response Format:** Always returns the updated case with the complete events array, ensuring consistency regardless of event type being updated.  **Benefits:** - Unified API for all timeline updates - No need for frontend to know about feedback IDs - Consistent response format - Clean, unambiguous design - Field-level permission validation 
     * Update case event
     */
    async updateEvent(requestParameters: UpdateEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseResponse> {
        const response = await this.updateEventRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCaseTypesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCaseTypesSortOrderEnum = typeof GetCaseTypesSortOrderEnum[keyof typeof GetCaseTypesSortOrderEnum];
/**
 * @export
 */
export const GetCasesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCasesSortOrderEnum = typeof GetCasesSortOrderEnum[keyof typeof GetCasesSortOrderEnum];
/**
 * @export
 */
export const GetCreatableCaseTypes1SortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCreatableCaseTypes1SortOrderEnum = typeof GetCreatableCaseTypes1SortOrderEnum[keyof typeof GetCreatableCaseTypes1SortOrderEnum];
